import React, { Component } from "react";
import axios from "axios";
import { apiUrl, apiUrl2, apiUrl3, genevent, distributor, telemetryApi } from "../../config/config";
import TopNav from "../common/TopNav";
import SideBar from "../../components/common/SideBar";
import Select from "react-select";
import $ from "jquery";
import { Toaster, toast } from "react-hot-toast";
import { performLogout } from "../../utils/logout";
import DeviceHistoryModal from "./DeviceHistoryModal";

import "./distributor.css";
import { Title } from "@material-ui/icons";

// Single source of truth for "has this patient's report been generated?".
// Used by the status tabs (Data Uploaded vs Report Ready), their counts, the
// Raw cell and the Confirm cell — so they can never disagree.
//
// A report is generated when ReportPublished is set, or ReportGeneration holds
// a real value. Both use "NA" / "" as "not yet" (matching the backend's own
// report queries), so those must NOT count. Analysis progress (report_status
// 2 = analysed, 6 = analysis completed) is deliberately NOT a signal here — an
// analysed patient without a report is still open for raw data and confirm.
const isSet = (v) => v != null && String(v).trim() !== "" && String(v).trim() !== "NA";
const isReportGenerated = (p) => isSet(p.ReportPublished) || isSet(p.ReportGeneration);

// Partner-facing report status — deliberately simple. Distributors don't
// need the internal analysis pipeline (analysed / verification / preparation
// stages); they only need to know whether the report is ready.
const reportStageOf = (row) => {
  const rs = Number(row.reportStatus);
  if (isReportGenerated(row) || rs === 5)
    return { label: "Report Ready", color: "#1e8449", bg: "rgba(30,132,73,0.12)" };
  return   { label: "Processing",   color: "#909ba3", bg: "rgba(144,155,163,0.14)" };
};

class Distributor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menus: [
        { title: "Patient List", url: "/Partner" },
        { title: "Device Details", url: "/device-home" },
        { title: "Add Accounts", url: "/add-accounts" },
      ],
      data: [], // Stores the table data
      profileLink: "verifier-profile",
      searchTerm: "", // Holds the current search term
      statusFilter: "processing", // Lifecycle tab: all | monitoring | processing | published — defaults to Under Processing (the partner's working queue)
      salesPartnerFilter: "all", // "all" | "__none" (unassigned) | exact sales partner name
      salesPartnerSelect: "", // primary dropdown pick ("" none, "__new" add-new)
      salesPartnerInput: "", // new name typed when primary "__new" is picked
      salesPartnerSelect2: "", // SECOND sales partner (optional)
      salesPartnerInput2: "", // new name typed when secondary "__new" is picked
      // "Add patient by Device ID" — links a patient whose device→patient
      // connection was missed, so it appears under this partner.
      addDeviceModalOpen: false,
      addDeviceId: "",
      addDeviceBusy: false,
      // Device control popup (opened by clicking a patient id) — mirrors the
      // telemetry dashboard: live status + remote-control commands.
      devDetail: null,      // { device_id, user_id, serial_no, name, ...live fields }
      devCommands: null,    // recent command history (null = loading)
      devBusy: "",          // "<label>:<cmd>" while a command is in flight
      devCustom: "",        // custom command text
      currentPage:  1,    // Current page for pagination
      itemsPerPage: 50,   // Rows per page (server-side paging — one page per request)
      totalRecords: 0,    // Total matching patients (from server response)
      totalPages:   1,    // Total number of pages (from server response)
      hasNextPage:  false,
      hasPrevPage:  false,
      statusCounts: null, // Per-status totals from the server (all pages)
      salesPartnerOptions: null, // Sales partner names across all pages (server)
      // Row whose DEVICE NO was clicked — opens the shared device-history
      // popup (same api/users/getSubsribe data the support and device pages
      // show), listing the patients that device has been connected to.
      historyRow: null,
      triggering: {},     // patient _id -> true while its upload trigger is in flight
      triggered: {},      // patient _id -> true once triggered this session
      maxPageButtons: 8, // Maximum number of page buttons to show
      sortColumn: "", // Column to sort by
      sortDirection: "asc", // Sort direction: 'asc' or 'desc'
      userid: "",
      patient_name: "",
      email_id: "",
      hospital: "",
      selectedDoctor: null,
      duration: "",
      dob: "",
      Phonenumber: "",
      mailuserid: "",
      customermailid: "",
      whatsappNumber: "",
      mailid: "",
      arrythymia: "",
      patientmailid: "",
      patientwhatsappNumber: "",
      patientmailsubject: "",
      patientwhatsappMessage: "",
      ipop: "",
      gender: "",
      pacemaker: false, // stored in the patient's hyper_lipidemia field
      doctors: [],
      errors: {},
      selectedDate: "",
      remarks: "",
      user_id: "",
      loadingEditModal: false, // Add loading state for edit modal
      showDeletedBeatsModal:false,
      deleteBeatNumber:"",
    };
    this.getInfo = this.getInfo.bind(this);
    this.getReport = this.getReport.bind(this);
  }

  componentDidMount() {
    // Initial fetch only — no auto-polling. The partner refreshes
    // manually via the ↻ Refresh button in the top bar, or by
    // performing an action that re-triggers fetchData() (edit modal,
    // share-report, etc.).
    this.fetchData();
  }

  componentWillUnmount() {
    clearTimeout(this._fdPollTimer);
  }

  clearShareReportState = () => {
    this.setState({
      customermailid: "",
      whatsappNumber: "",
      mailid: "",
      arrythymia: "",
      patientmailid: "",
      patientwhatsappNumber: "",
      patientmailsubject: "",
      patientwhatsappMessage: "",
    });
  };

  // Maps ONE raw patient document from the API into the row shape the table
  // renders. Extracted from fetchData so the CSV export can reuse it when it
  // pulls every page — otherwise "Export CSV" would only ever write the page
  // currently on screen.
  mapPatientRow = (patient, index) => {
    // Safely read subscribeLogs — fall back to now if missing
    const rawDateSub =
      patient.subscribeLogs &&
      patient.subscribeLogs.length > 0 &&
      patient.subscribeLogs[0].date_sub
        ? patient.subscribeLogs[0].date_sub
        : null;

    let adjustedDate;
    if (rawDateSub) {
      adjustedDate = new Date(rawDateSub.split(".")[0]);
      adjustedDate.setHours(adjustedDate.getHours() + 5);
      adjustedDate.setMinutes(adjustedDate.getMinutes() + 30);
    } else {
      adjustedDate = new Date(); // fallback: treat as just subscribed
    }

    const now = new Date(); // Get the current time
    const timeDifference = now - adjustedDate; // Difference in milliseconds

    // Convert the difference to hours
    const diffInSeconds = Math.floor(timeDifference / 1000); // seconds
    const diffInMinutes = Math.floor(diffInSeconds / 60); // minutes
    const diffInHours = Math.floor(diffInMinutes / 60); // hours
    const diffInDays = Math.floor(diffInHours / 24); // days

    // console.log(
    //   `Current Time: ${now.toLocaleString().replace(",", "")}`
    // );
    // console.log(
    //   `Adjusted Time: ${adjustedDate.toLocaleString().replace(",", "")}`
    // );
    // console.log(
    //   `Time Difference: ${diffInDays} days, ${
    //     diffInHours % 24
    //   } hours, ${diffInMinutes % 60} minutes`
    // );

    // Monitoring duration logic
    const monitoringDuration = patient.exp_device_use_days; // Example monitoringDuration (1 = 24hrs, 2 = 48hrs, 3 = 72hrs)
    const maxDurationInHours = monitoringDuration * 24; // Convert to hours (1 -> 24hrs, 2 -> 48hrs, etc.)

    // Declare the variable outside of the if statement
    let percentageUsed = 0;

    // Calculate the percentage only if the time difference is within the allowed limit
    if (diffInHours <= maxDurationInHours) {
      // Calculate the percentage of time used towards the limit
      percentageUsed = (diffInHours / maxDurationInHours) * 100;
      // console.log(
      //   `Percentage of time used: ${percentageUsed.toFixed(2)}%`
      // );
    } else {
      // console.log(
      //   `Time difference exceeds the allowed limit of ${maxDurationInHours} hours.`
      // );
    }

    // Now you can use the percentageUsed variable here outside the if statement
    // console.log(
    //   `Percentage Used (Outside): ${percentageUsed.toFixed(2)}%`
    // );

    return {
      slno: index + 1,
      QC: patient.QC || false,
      patientId: patient.device_id || "N/A",
      name: patient.name || "N/A",
      createdDate: patient.created_at
        ? patient.created_at.split("T")[0]
        : "N/A",
      // Registration time (HH:MM) from created_at, shown under the date.
      createdTime: patient.created_at && patient.created_at.indexOf("T") !== -1
        ? (patient.created_at.split("T")[1] || "").slice(0, 5)
        : "",
      duration: `${patient.exp_device_use_days} (${adjustedDate
        .toLocaleString()
        .replace(",", "")})`, // Update duration
      percentage: `${percentageUsed || "100"}`, // Add the percentage of elapsed monitoring time
      phone: patient.phone || "N/A",
      // phone:patient.phone || "N/A",  
      userid: patient._id,
      mailId: patient.email || "N/A",
      gender: patient.gender || "N/A",
      battery: `${patient.BatteryPercentage}%` || "N/A",
      recordingStatus: (() => {
        switch (patient.RecordingStatus) {
          case 0:
            return "Not Recording";
          case 1:
            return "In Recording";
          case 3:
            return "Data Upload";
          default:
            return "N/A";
        }
      })(),
      uploadedTime: patient.updatedDate || "_",
      doctorName: patient.doctorName || "N/A",
      hospitalName: patient.hospital || "N/A",
      fileCount: patient.data_count || "N/A",
      // Number of ECG datasets uploaded (ECGValue docs) — total files,
      // NOT the verified count. Backend attaches ecgDatasetCount;
      // fall back to data_count for older backends.
      ecgDatasetCount:
        patient.ecgDatasetCount != null
          ? patient.ecgDatasetCount
          : (typeof patient.data_count === "number" ? patient.data_count : 0),
      // Serial comes from the joined device row; the backend also
      // sends a flat serial_no (resolved via the patient's own Mac_id
      // when no subscribe log exists), so fall back to that before
      // giving up — this is why DEVICE NO read "N/A" here while the
      // support page showed it.
      devicenumber:
        (patient.deviceInfo && patient.deviceInfo.serial_no) ||
        patient.serial_no ||
        "N/A",
      // Mac of the device this patient is on — the key the device history
      // lookup (getSubsribe) takes. Prefer the patient's own stamped Mac_id,
      // fall back to the resolved device row.
      macId:
        patient.Mac_id ||
        patient.mac_id ||
        (patient.deviceInfo && patient.deviceInfo.mac_id) ||
        "",
      device_Sub_time: rawDateSub || "N/A",
      updatedDate: patient.updatedDate,
      ReportPublished: patient.ReportPublished,
      whatsappSentTime: patient.whatsappsenttime || "N/A",
      mailsentime: patient.mailsentime || "N/A",
      ipop: patient.ip_op || "N/A",
      remarks: patient.remarks || patient.Remarks || "",
      salesPartner: patient.salesPartner || patient.sales_partner || "",
      salesPartner2: patient.salesPartner2 || patient.sales_partner2 || "",
      // Raw-data link + confirmation (partner workflow)
      ReportGeneration: patient.ReportGeneration || "",
      reportStatus: patient.report_status,
      expDays: patient.exp_device_use_days != null ? patient.exp_device_use_days : "",
      lastDatasetId: patient.LastDatasetId || "",
      backupStatus: patient.backup_status,
      Confirmation: patient.Confirmation || "No",
      ConfirmupdatedDate: patient.ConfirmupdatedDate || null,
      ConfirmedBy: patient.ConfirmedBy || "",
      ConfirmationSource: patient.ConfirmationSource || "",
    };
  };

  // Fetch ONE page of patients from the server (server-side pagination).
  // Status tab, search text, date range and sales partner are all sent along
  // so the server filters across ALL of the partner's patients — not just the
  // loaded page — and returns true per-status counts for the tab badges.
  fetchData = async (page) => {
    this.loadFdRequests();   // Refresh also picks up FD outcomes (requested → sent / failed)
    try {
      const verifiertype = localStorage.getItem("verifiertype");
      const customerid = localStorage.getItem("verifierid");
      const pageToFetch = Number(page) > 0
        ? Number(page)
        : (this.state.currentPage || 1);
      const limit = this.state.itemsPerPage || 50;

      const response = await axios.get(
        `${apiUrl}api/users/getVerifierPatientsPercentage_testnew`,
        {
          params: {
            userid: customerid,
            page:   pageToFetch,
            limit:  limit,
            status: this.state.statusFilter || "all",
            search: (this.state.searchTerm || "").trim(),
            // Date range and sales partner go to the SERVER too, so they
            // narrow the whole list rather than just the loaded page.
            startDate: this.state.startDate || "",
            endDate: this.state.endDate || "",
            salesPartner: this.state.salesPartnerFilter || "all",
          },
        }
      );

      if (response.data && response.data.patients) {
        // Filter out "Device Testing" rows only. The server already sorts
        // by created_at (newest first) with _id as a stable tie-breaker AND
        // paginates in that same order — re-sorting the page here with a
        // different fallback key made rows shuffle within a page and
        // interleave across pages, so we now trust the server's order.
        const sortedPatients = response.data.patients
          .filter((patient) => patient.doctorName !== "Device Testing");

        // Pull the pagination meta the route returns and pin it to state
        // so the pager UI can render Prev/Next + page-count correctly.
        const pg = response.data.pagination || {};
        const alldoctors = await axios.get(`${apiUrl}api/users/alldoctors`);
        // console.log(alldoctors.data);
        this.setState({ doctors: alldoctors.data });

        this.setState({
          data: sortedPatients.map(this.mapPatientRow),
          // Server-side pagination: totals, page bounds and per-status counts
          // all come from the server's `pagination` object. (Falls back to
          // treating the response as a single page if an older backend
          // without pagination is ever hit.)
          currentPage:   pg.page || pageToFetch,
          itemsPerPage:  pg.limit || limit,
          totalRecords:  pg.total != null ? pg.total : sortedPatients.length,
          totalPages:    pg.totalPages || 1,
          hasNextPage:   pg.hasNext === true,
          hasPrevPage:   pg.hasPrev === true,
          statusCounts:  pg.counts || null,
          // Dropdown options computed over the WHOLE set by the server, so
          // picking a name isn't limited to partners present on this page.
          salesPartnerOptions:
            (response.data.meta && response.data.meta.salesPartnerOptions) || null,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Step 1: open the confirm dialog, pre-filled with the patient's current
  // monitoring duration so the partner can review/adjust it before confirming.
  confirmPatient = (row) => {
    if (!row || !row.userid || row.ConfirmupdatedDate) return;
    this.setState({
      confirmTarget: row,
      confirmDays: row.expDays !== "" && row.expDays != null ? String(row.expDays) : "",
      confirmError: "",
      confirmBusy: false,
    });
  };

  closeConfirmDialog = () =>
    this.setState({ confirmTarget: null, confirmDays: "", confirmError: "", confirmBusy: false });

  // ── Request FD (Full Disclosure report) ─────────────────────────────
  // The latest request per patient, keyed by patient id. Kept separate from
  // the patient rows so the (large, paginated) list route does not have to
  // change; an older backend without this route simply shows no FD status.
  loadFdRequests = () => {
    axios.get(`${apiUrl}api/users/partnerFdRequests`)
      .then((res) => {
        const requests = (res.data && res.data.requests) || {};
        this.setState({ fdRequests: requests });
        // Keep polling every 5s while anything is still generating/queued,
        // so "processing" flips to "sent"/"failed" without a manual refresh.
        // Generation can take well over a minute for a multi-day history,
        // so a single one-off check isn't enough.
        const stillPending = Object.values(requests).some(
          (r) => r && (r.status === "requested" || r.status === "processing")
        );
        if (stillPending) {
          clearTimeout(this._fdPollTimer);
          this._fdPollTimer = setTimeout(this.loadFdRequests, 5000);
        }
      })
      .catch(() => {});
  };

  // Step 1: open the dialog. Pre-filled with where the last FD for this patient
  // went, otherwise with the partner's own e-mail — the usual answer either way.
  openFdDialog = (row) => {
    if (!row || !row.userid) return;
    const last = (this.state.fdRequests || {})[row.userid];
    const own = localStorage.getItem("verifieremail") || "";
    this.setState({
      fdTarget: row,
      fdEmails: last && last.emails && last.emails.length ? last.emails.join(", ") : own,
      fdNote: "",
      fdError: "",
      fdBusy: false,
    });
  };

  closeFdDialog = () =>
    this.setState({ fdTarget: null, fdEmails: "", fdNote: "", fdError: "", fdBusy: false });

  // Step 2: submit. The server records WHO asked (from the login) + WHEN,
  // checks the patient belongs to this partner, and starts the FD generator.
  submitFd = async () => {
    const row = this.state.fdTarget;
    if (!row || this.state.fdBusy) return;
    const emails = String(this.state.fdEmails || "").split(/[\s,;]+/).map((e) => e.trim()).filter(Boolean);
    if (!emails.length) { this.setState({ fdError: "Enter the e-mail address the FD should be sent to." }); return; }
    if (emails.length > 5) { this.setState({ fdError: "At most 5 e-mail addresses." }); return; }
    const bad = emails.filter((e) => !/^[^\s@<>(),;:"]+@[^\s@<>(),;:"]+\.[A-Za-z]{2,}$/.test(e));
    if (bad.length) { this.setState({ fdError: "Not a valid e-mail address: " + bad.join(", ") }); return; }

    this.setState({ fdBusy: true, fdError: "" });
    try {
      const res = await axios.post(`${apiUrl}api/users/partnerRequestFd`, {
        patientId: row.userid,
        emails: emails,
        note: this.state.fdNote || "",
      });
      const r = (res.data && res.data.request) || {};
      const prev = (this.state.fdRequests || {})[row.userid];
      this.setState((st) => ({
        fdRequests: {
          ...(st.fdRequests || {}),
          [row.userid]: {
            id: r.id, status: r.status || "requested", requestedAt: r.requestedAt || new Date().toISOString(),
            emails: r.emails || emails, requestedBy: r.requestedBy || "", count: (prev ? prev.count : 0) + 1,
          },
        },
        fdTarget: null, fdEmails: "", fdNote: "", fdError: "", fdBusy: false,
      }));
      toast.success(`FD requested for ${row.name || row.patientId}. It will take 5-10 minutes at this time. Please check your mail (${(r.emails || emails).join(", ")}).`, { autoClose: 10000 });
      // The generator runs in the background — pick up its outcome shortly.
      setTimeout(this.loadFdRequests, 8000);
    } catch (err) {
      const status = err.response && err.response.status;
      const msg =
        (err.response && err.response.data && (err.response.data.error || err.response.data.message)) ||
        (status === 404 ? "FD requests are not enabled on the server yet." : "Could not send the request — please try again.");
      this.setState({ fdError: msg, fdBusy: false });
      if (status === 409) this.loadFdRequests();
    }
  };

  // ── Add a patient to THIS partner's dashboard by device id ──────────
  // Used when the device→patient link was missed at recording time, so the
  // patient never appears under the partner. Stamps this partner's customer
  // identity onto the patient (the canonical link the whole dashboard uses),
  // so it then shows here AND on patient-list with the right distributor.
  openAddDeviceModal = () =>
    this.setState({ addDeviceModalOpen: true, addDeviceId: "", addDeviceBusy: false });

  closeAddDeviceModal = () =>
    this.setState({ addDeviceModalOpen: false, addDeviceId: "", addDeviceBusy: false });

  addPatientByDevice = (force = false) => {
    // The 6-digit id is the Patient ID in the UI (backend still keys off
    // the device_id field, which is the same number).
    const device_id = String(this.state.addDeviceId || "").trim();
    if (!/^\d{3,}$/.test(device_id)) {
      toast.error("Enter a valid Patient ID (digits only).");
      return;
    }
    const partnerId = localStorage.getItem("verifierid");
    this.setState({ addDeviceBusy: true });
    axios
      .post(`${apiUrl}api/users/partnerAddPatientByDevice`, { partnerId, device_id, force })
      .then((res) => {
        this.setState({ addDeviceBusy: false, addDeviceModalOpen: false, addDeviceId: "" });
        toast.success((res.data && res.data.message) || "Patient added to your dashboard.");
        this.fetchData(1);
      })
      .catch((err) => {
        this.setState({ addDeviceBusy: false });
        const status = err.response && err.response.status;
        const d = err.response && err.response.data;
        // Patient already belongs to another customer → confirm the move.
        if (status === 409 && d && d.needsConfirm) {
          if (window.confirm((d.message || "This patient is under another customer.") + "\n\nMove it to your dashboard?")) {
            this.addPatientByDevice(true);
          }
          return;
        }
        // Surface the REAL reason so it's debuggable, not a generic message.
        const reason =
          (d && (d.error || d.message)) ||
          (status === 404 ? "Route not found — the add-patient endpoint isn't deployed on this server yet."
            : status === 401 ? "Not authorised — please log in again."
            : status ? "Server returned " + status
            : "No response from server (network / CORS).");
        toast.error("Couldn't add Patient ID " + device_id + ": " + reason);
      });
  };

  // ── Device control popup (click a patient id) ───────────────────────
  // Seeds from the row, then pulls this device's LIVE status from the
  // telemetry backend (web6) and merges it in — same status + commands as
  // the telemetry dashboard.
  openDevicePopup = (row) => {
    // Only keep a real numeric device id; a missing one is "N/A" on the row
    // and must NOT be sent as the device_id (the command would target the
    // literal string "N/A"). Commands then fall back to user_id (Mongo _id),
    // which the backend also accepts.
    const did = /^\d+$/.test(String(row.patientId || "")) ? String(row.patientId) : null;
    if (!did && !row.userid) {
      toast.error("This patient has no device id — cannot open controls.");
      return;
    }
    const seed = {
      device_id: did,
      user_id: row.userid || null,
      serial_no: row.devicenumber && row.devicenumber !== "N/A" ? row.devicenumber : null,
      name: row.name,
    };
    this.setState({ devDetail: seed, devCommands: null, devCustom: "" });
    this.loadDeviceLive(seed);
    this.loadDeviceCommands(seed);
  };

  closeDevicePopup = () =>
    this.setState({ devDetail: null, devCommands: null, devCustom: "", devBusy: "" });

  // Find this device in the telemetry /live feed and merge its live fields.
  loadDeviceLive = (seed) => {
    axios
      .get(`${telemetryApi}api/telemetry/live`)
      .then((res) => {
        const list = (res.data && res.data.devices) || [];
        const match = list.find(
          (x) =>
            String(x.device_id) === String(seed.device_id) ||
            String(x.user_id) === String(seed.user_id)
        );
        // Only merge if the popup is still open on the SAME device. Guard on
        // user_id (unique Mongo _id) — device_id can be null for un-tagged
        // rows, so it isn't a reliable key.
        this.setState((prev) => {
          if (!prev.devDetail || String(prev.devDetail.user_id) !== String(seed.user_id)) {
            return null;
          }
          // Preserve the seed's device_id/serial if the live row omits them.
          const merged = { ...prev.devDetail, ...(match || {}) };
          if (!merged.device_id) merged.device_id = prev.devDetail.device_id;
          if (!merged.serial_no) merged.serial_no = prev.devDetail.serial_no;
          return { devDetail: merged };
        });
      })
      .catch(() => { /* keep the seed; status stays "—" */ });
  };

  loadDeviceCommands = (seed) => {
    const p = new URLSearchParams();
    if (seed.device_id) p.set("device_id", seed.device_id);
    else if (seed.user_id) p.set("user_id", seed.user_id);
    axios
      .get(`${telemetryApi}api/telemetry/commands?` + p.toString())
      .then((res) => {
        // Ignore a stale response if the popup moved to another device.
        this.setState((prev) => {
          if (!prev.devDetail || String(prev.devDetail.user_id) !== String(seed.user_id)) {
            return null;
          }
          return { devCommands: (res.data && res.data.commands) || [] };
        });
      })
      .catch(() => {
        this.setState((prev) =>
          prev.devDetail && String(prev.devDetail.user_id) === String(seed.user_id)
            ? { devCommands: [] }
            : null
        );
      });
  };

  sendDeviceCommand = (cmd, params) => {
    const d = this.state.devDetail;
    if (!d) return;
    const command = String(cmd || "").trim();
    if (!command) return;
    const label = String(d.device_id || d.user_id || "");
    const key = label + ":" + command;
    this.setState({ devBusy: key });
    axios
      .post(`${telemetryApi}api/telemetry/command`, {
        device_id: d.device_id || null,
        user_id: d.user_id || null,
        command: command,
        params: params || undefined,
        requestedBy: localStorage.getItem("verifiername") || "partner",
      })
      .then(() => {
        this.setState({ devBusy: "", devCustom: "" });
        this.loadDeviceCommands(d);
        // Mode commands change the badge only once the device acks + posts a
        // fresh status. Re-pull /live and the command log shortly after so the
        // "Monitoring mode" row and the command's ack detail update on their own.
        if (command === "mode_remote" || command === "mode_standalone" || command === "set_mode") {
          setTimeout(() => { this.loadDeviceLive(d); this.loadDeviceCommands(d); }, 2000);
        }
      })
      .catch((err) => {
        this.setState({ devBusy: "" });
        const msg = (err.response && err.response.data && err.response.data.error) || err.message;
        toast.error(
          'Command "' + command + '" failed: ' + msg +
          (err.response && err.response.status === 404
            ? " — telemetry command routes not deployed."
            : "")
        );
      });
  };

  // Step 2: submit. The server records WHO (from the JWT) + WHEN, saves the
  // (possibly adjusted) monitoring duration, and only allows patients in this
  // partner's scope.
  submitConfirm = async () => {
    const row = this.state.confirmTarget;
    if (!row) return;
    const days = Number(this.state.confirmDays);
    if (!Number.isInteger(days) || days < 1 || days > 90) {
      this.setState({ confirmError: "Enter monitoring duration as whole days (1–90)." });
      return;
    }
    this.setState({ confirmBusy: true, confirmError: "" });
    try {
      const res = await axios.post(`${apiUrl}api/users/partnerConfirmPatient`, {
        patientId: row.userid,
        monitoringDays: days,
      });
      const p = (res.data && res.data.patient) || {};
      // Update the row in place — no full refetch needed.
      this.setState((prev) => ({
        data: (prev.data || []).map((r) =>
          r.userid === row.userid
            ? {
                ...r,
                Confirmation: p.Confirmation || "Yes",
                ConfirmupdatedDate: p.ConfirmupdatedDate || new Date().toISOString(),
                ConfirmedBy: p.ConfirmedBy || localStorage.getItem("verifiername") || "Partner",
                ConfirmationSource: p.ConfirmationSource || "partner",
                expDays: p.exp_device_use_days != null ? p.exp_device_use_days : days,
                duration: r.duration ? String(r.duration).replace(/^\S+/, String(days)) : r.duration,
              }
            : r
        ),
        confirmTarget: null, confirmDays: "", confirmError: "", confirmBusy: false,
      }));
    } catch (err) {
      const msg =
        (err.response && err.response.data && (err.response.data.error || err.response.data.message)) ||
        "Could not confirm — please try again.";
      this.setState({ confirmError: msg, confirmBusy: false });
    }
  };

  // Ask the device to upload its recorded data now.
  //
  // Endpoint: POST {apiUrl2}api/androidapi/dataUploadNotification
  //   -> https://data.mybiocalculus.com/api/api/androidapi/dataUploadNotification
  // (apiUrl2's base already ends in /api/, hence the doubled segment.)
  //
  // The route takes `userId` (capital I) and kicks off
  // Data_upload/trigger_data.py for that patient. It also does
  // `$set: { data_count: filesuploaded }` — we send 0, so the patient's file
  // count resets and re-accumulates as the fresh upload lands.
  triggerUpload = async (row) => {
    if (!row || !row.userid) return;
    const id = row.userid;
    if (this.state.triggering[id]) return;             // already in flight
    this.setState((prev) => ({ triggering: { ...prev.triggering, [id]: true } }));
    try {
      const res = await axios.post(
        `${apiUrl2}api/androidapi/dataUploadNotification`,
        { userId: id, filesuploaded: 0 }
      );
      const ok = !res.data || !res.data.error;
      if (ok) {
        toast.success(`Upload triggered for ${row.name || row.patientId}`);
        this.setState((prev) => ({ triggered: { ...prev.triggered, [id]: true } }));
      } else {
        toast.error(
          (res.data && res.data.error) || "Trigger failed — please try again."
        );
      }
    } catch (err) {
      const msg =
        (err.response && err.response.data &&
          (err.response.data.error || err.response.data.message)) ||
        "Trigger failed — please try again.";
      toast.error(msg);
    } finally {
      this.setState((prev) => {
        const t = { ...prev.triggering };
        delete t[id];
        return { triggering: t };
      });
    }
  };

  // Open the raw (unanalysed) data view for a patient in a new tab.
  // Partners see raw data only — never the analysed verifier chart.
  openRawData = (row) => {
    if (!row || !row.userid) return;
    const url = `/verifier-unanalysed/${row.userid}` + (row.lastDatasetId ? `/${row.lastDatasetId}` : "");
    window.open(url, "_blank", "noopener");
  };

  // Jump to a page: server-side paging, so fetch that page. Clamped to the
  // server-reported range; scrolls the table back to the top on arrival.
  goToPage = (n) => {
    const totalPages = this.state.totalPages || 1;
    const target = Math.max(1, Math.min(n, totalPages));
    if (target === this.state.currentPage) return;
    // Update immediately so the pager highlights before the request resolves.
    this.setState({ currentPage: target }, async () => {
      await this.fetchData(target);
      const wrap = document.querySelector(".dp-tbl-wrap");
      if (wrap) wrap.scrollTop = 0;
    });
  };

  // Search runs on the SERVER (across all pages), so re-fetch page 1 —
  // debounced so we don't fire a request on every keystroke.
  handleSearchChange = (event) => {
    const value = event.target.value;
    this.setState({ searchTerm: value, currentPage: 1 });
    clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => this.fetchData(1), 350);
  };
  handleDeleteBeatClick(){
    this.setState({showDeletedBeatsModal:true})
  }
  handleDeleteBeatModalClose(){
    this.setState({showDeletedBeatsModal:false,deleteBeatNumber:""})
  }
  // handleDeleteBeatConfirm(){
  //   const beatNumber= this.state.deleteBeatNumber;
  //   if (!beatNumber || isNaN())
  // }
  onSubmitInfo = (e) => {
    e.preventDefault();

    const info = {
      // core identifiers
      userid: this.state.userid,
      patientid: this.state.userid,
      // editable fields
      name: this.state.patient_name,
      hospital: this.state.hospital,
      phone: this.state.Phonenumber,
      email: this.state.email_id,
      doctorid: this.state.selectedDoctor ? this.state.selectedDoctor.value : "",
      ipop: this.state.ipop,
      exp_device_use_days: this.state.duration,
      gender: this.state.gender,
      // fields required by the endpoint but not used on this page
      fileType: "easy",
      verifierid: [],
      priority: "",
      reportstatus: "",
      af: "",
      hyper_lipidemia: this.state.pacemaker, // pacemaker Yes/No
      indication: "",
      cardiac_surgery: "",
      thyroid: "",
      issueReported: "",
      supportLevel: "",
      supportPerson: "",
      supportcomment: "",
      prioritizeData: "",
      clinicalCondition: "",
    };

    this.setState({ loadingEditModal: true });
    console.log("[Save] posting to:", apiUrl + "api/patients/updateInfo_new_info_test", info);

    axios
      .post(apiUrl + "api/patients/updateInfo_new_info_test", info)
      .then((res) => {
        console.log("[Save] success:", res.data);
        this.setState({ loadingEditModal: false });
        toast.success("Patient info updated!");
        $(".closePopup").click();
        this.fetchData();
      })
      .catch((err) => {
        console.error("[Save] error:", err.message, err.response && err.response.data);
        this.setState({ loadingEditModal: false });
        toast.error("Save failed: " + (err.response ? err.response.status : err.message));
      });
  };

  // Pulls EVERY page matching the current filters, so the CSV covers the whole
  // result set rather than the page on screen. Only runs on an explicit click,
  // so the normal browsing path still transfers one page at a time.
  fetchAllRowsForExport = async () => {
    const customerid = localStorage.getItem("verifierid");
    const limit = 50;               // server hard-caps at 50 per request
    const MAX_PAGES = 400;          // 20k rows — a guard, not an expected bound
    const all = [];
    let page = 1;
    while (page <= MAX_PAGES) {
      const response = await axios.get(
        `${apiUrl}api/users/getVerifierPatientsPercentage_testnew`,
        {
          params: {
            userid: customerid,
            page,
            limit,
            status: this.state.statusFilter || "all",
            search: (this.state.searchTerm || "").trim(),
            startDate: this.state.startDate || "",
            endDate: this.state.endDate || "",
            salesPartner: this.state.salesPartnerFilter || "all",
          },
        }
      );
      const batch = (response.data && response.data.patients) || [];
      all.push(...batch.filter((pt) => pt.doctorName !== "Device Testing"));

      const pg = (response.data && response.data.pagination) || null;
      // No pagination block => non-paginated backend, everything already came
      // back in one response. Otherwise stop when the server says no next page.
      if (!pg || pg.hasNext !== true || batch.length === 0) break;
      page += 1;
    }
    return all.map(this.mapPatientRow);
  };

  handleExportToCSV = async () => {
    const { searchTerm, sortColumn, sortDirection } = this.state;

    // Every matching row, not just the loaded page.
    let filteredData;
    try {
      filteredData = await this.fetchAllRowsForExport();
    } catch (err) {
      console.error("[Export] failed:", err.message);
      toast.error("Export failed — showing the current page only");
      filteredData = this.getFilteredData();
    }
    if (sortColumn) {
      filteredData = [...filteredData].sort((a, b) => {
        if (sortColumn === "createdDate") {
          const dateA = new Date(a[sortColumn]);
          const dateB = new Date(b[sortColumn]);
          return sortDirection === "asc" ? dateA - dateB : dateB - dateA;
        }
        const valueA = String(a[sortColumn]).toLowerCase();
        const valueB = String(b[sortColumn]).toLowerCase();
        return sortDirection === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      });
    }

    // Convert data to CSV format
    const csvRows = [];
    const headers = [
      "SL NO",
      "PATIENT ID",
      "NAME",
      "CREATED DATE",
      "DURATION",
      "PHONE",
      "MAIL ID",
      "GENDER",
      "BATTERY",
      "RECORDING STATUS",
      "UPLOADED TIME",
      "ECG FILES",
      "REPORT STATUS",
      "DOCTOR NAME",
      "HOSPITAL NAME",
      "SERIAL_NO",
      "FILE COUNT",
      "IP/OP",
      "SALES PARTNER",
      "REMARKS",
    ];
    csvRows.push(headers.join(",")); // Add headers

    filteredData.forEach((row) => {
      const values = [
        row.slno,
        row.patientId,
        row.name,
        row.createdDate,
        row.duration,
        row.phone,
        row.mailId,
        row.gender,
        row.battery,
        row.recordingStatus,
        row.uploadedTime,
        row.ecgDatasetCount != null ? row.ecgDatasetCount : 0,
        reportStageOf(row).label,
        row.doctorName,
        row.hospitalName,
        row.devicenumber,
        row.fileCount,
        row.ipop,
        row.salesPartner || "",
        row.remarks || "",
      ];
      csvRows.push(values.map((value) => `"${value}"`).join(",")); // Add row values
    });

    // Create a Blob and trigger download
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Filtered_Distributor_Data.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  // Local filters over the loaded page. Search text and the status tab are
  // applied on the SERVER (so they cover all pages) and must NOT be re-applied
  // here — a local re-match would hide server-matched rows. Only the date
  // range and sales-partner filters are client-side.
  getFilteredData = () => {
    const { data, startDate, endDate } = this.state;

    return data.filter((patient) => {
      // Convert patient date to match input format
      const patientDate = patient.createdDate
        ? patient.createdDate.split("T")[0]
        : "";

      // Convert input dates to Date objects for comparison
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;
      const current = new Date(patientDate);

      // Search: applied locally AS WELL AS server-side, so it works no
      // matter which backend variant is deployed — the non-paginated
      // route ignores the `search` param and returns everything, which
      // made the search box appear dead.
      const q = (this.state.searchTerm || "").trim().toLowerCase();
      const matchesSearch =
        !q ||
        [
          patient.patientId,
          patient.name,
          patient.phone,
          patient.doctorName,
          patient.hospitalName,
          patient.devicenumber,
        ].some((v) => v != null && String(v).toLowerCase().includes(q));
      // Lifecycle tabs: applied locally AS WELL AS server-side — the
      // non-paginated backend variant ignores the status param, which
      // left the chips doing nothing (same issue the search box had).
      //   monitoring  → not yet uploaded (still recording / idle), no report
      //   processing  → uploaded; verification / reporting in progress
      //   published   → report generated
      const sf = this.state.statusFilter || "all";
      const matchesStatus =
        sf === "all"
          ? true
          : sf === "monitoring"
          ? patient.recordingStatus !== "Data Upload" && !isReportGenerated(patient)
          : sf === "processing"
          ? patient.recordingStatus === "Data Upload" && !isReportGenerated(patient)
          : sf === "published"
          ? isReportGenerated(patient)
          : true;

      // Check if patient date falls within the selected range
      const matchesDate =
        (!start || current >= start) && (!end || current <= end);

      // Sales partner filter — lets the distributor pull the list for
      // one of their sales partners ("__none" lists unassigned patients)
      const spf = this.state.salesPartnerFilter || "all";
      const spVal = String(patient.salesPartner || "").trim();
      const matchesSalesPartner =
        spf === "all" ? true : spf === "__none" ? !spVal : spVal === spf;

      return matchesSearch && matchesDate && matchesStatus && matchesSalesPartner;
    });
  };
  sentWhatsappReportPatient = async (e) => {
    const number = this.state.patientwhatsappNumber;
    const userid = this.state.mailuserid;
    const arrythymia = this.state.arrythymia || "NA";

    if (!arrythymia || !number) {
      toast.error("Enter WhatsApp number to proceed");
      return;
    }

    var apiUrl = `${apiUrl}api/common/whatsapp_integration`;

    var requestBody = {
      user_id: userid,
      arrythymia: arrythymia,
      number: number,
    };

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send WhatsApp message.");
          return data;
        })
      )
      .then((data) => {
        toast.success("WhatsApp message sent successfully!");
      })
      .catch((error) => {
        toast.error(
          error.message || "An error occurred while sending WhatsApp message."
        );
      });
  };
  // Sort data by selected column
  handleSort = (column) => {
    const { data, sortColumn, sortDirection } = this.state;
    let newDirection = "asc";

    if (sortColumn === column && sortDirection === "asc") {
      newDirection = "desc";
    }

    const sortedData = [...data].sort((a, b) => {
      if (column === "createdDate") {
        const dateA = new Date(a.createdDate);
        const dateB = new Date(b.createdDate);
        return newDirection === "asc" ? dateA - dateB : dateB - dateA;
      }

      if (column === "slno" || column === "patientId" || column === "name") {
        const valueA = String(a[column]).toLowerCase();
        const valueB = String(b[column]).toLowerCase();
        return newDirection === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      return 0; // Fallback for other columns
    });

    this.setState({
      data: sortedData,
      sortColumn: column,
      sortDirection: newDirection,
    });
  };
  getInfo(e) {
    var userid = e.currentTarget.id;

    // console.log("current target", e.currentTarget);
    this.setState({ userid: userid });
    this.setState({ mailuserid: userid });
    this.setState({ loadingEditModal: false }); // Start loading
    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];
        if (
          data.gender === "MALE" ||
          data.gender === "male" ||
          data.gender === "Male" ||
          data.gender === "M" ||
          data.gender === "m"
        ) {
          this.setState({ gender: "M" });
        }

        if (
          data.gender === "FEMALE" ||
          data.gender === "female" ||
          data.gender === "Female" ||
          data.gender === "F" ||
          data.gender === "f"
        ) {
          this.setState({ gender: "F" });
        }
        if (data.gender === "Select Gender") {
          this.setState({ gender: "M" });
        }

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        data.customer_details.forEach((customer) => {
          if (customer.customer_details) {
            // console.log('Nested Customer Details:', customer);
            this.setState({ customer_details: customer.customer_details });
          }
        });
        // console.log(this.state.patients);

        // Update state with patient info
        this.setState({
          duration: data.exp_device_use_days,

          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          Phonenumber: data.phone,
          ipop: data.ip_op,
          dob: data.dob,
          duration: data.exp_device_use_days,
          // Pacemaker is stored in hyper_lipidemia (true/false).
          pacemaker: data.hyper_lipidemia === true || data.hyper_lipidemia === "true",
        });

        // Handle DOB formatting
        const dob = new Date(Date.parse(data.dob));
        const formattedDob = `${
          dob.getMonth() + 1
        }/${dob.getDate()}/${dob.getFullYear()}`;
        this.setState({ dob: formattedDob });

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients,
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );

        this.setState({ selectedVerifiers: filteredVerifiers });
        this.setState({ verifiers: formattedVerifiers });

        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues;
        const totalLength = ecgValues.length;
        let verifyCount = 0;

        ecgValues.forEach((value) => {
          if (value.verifyStatus === 1) verifyCount++;
        });

        if (totalLength > 0) {
          const percentageVerified = (verifyCount / totalLength) * 100;
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
        }
      })
      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingEditModal: false });
      });
  }
  getReport(userid) {
    this.setState({ userid: userid });
    this.setState({ mailuserid: userid });

    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];
        if (
          data.gender === "MALE" ||
          data.gender === "male" ||
          data.gender === "Male" ||
          data.gender === "M" ||
          data.gender === "m"
        ) {
          this.setState({ gender: "M" });
        }

        if (
          data.gender === "FEMALE" ||
          data.gender === "female" ||
          data.gender === "Female" ||
          data.gender === "F" ||
          data.gender === "f"
        ) {
          this.setState({ gender: "F" });
        }
        if (data.gender === "Select Gender") {
          this.setState({ gender: "M" });
        }

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        data.customer_details.forEach((customer) => {
          if (customer.customer_details) {
            // console.log('Nested Customer Details:', customer);
            this.setState({ customer_details: customer.customer_details });
          }
        });
        // console.log(this.state.patients);

        // Update state with patient info
        this.setState({
          duration: data.exp_device_use_days,

          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          Phonenumber: data.phone,
          ipop: data.ip_op,
          dob: data.dob,
          duration: data.exp_device_use_days,
          // Pacemaker is stored in hyper_lipidemia (true/false).
          pacemaker: data.hyper_lipidemia === true || data.hyper_lipidemia === "true",
        });

        // Handle DOB formatting
        const dob = new Date(Date.parse(data.dob));
        const formattedDob = `${
          dob.getMonth() + 1
        }/${dob.getDate()}/${dob.getFullYear()}`;
        this.setState({ dob: formattedDob });

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients,
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );

        this.setState({ selectedVerifiers: filteredVerifiers });
        this.setState({ verifiers: formattedVerifiers });

        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        const totalLength = ecgValues.length;
        let verifyCount = 0; // Initialize verify count

        ecgValues.forEach((value, index) => {
          if (value.verifyStatus === 1) {
            // console.log(`Link for ECG value at index ${index}:`, value.link); // Assuming there's a 'link' property
            verifyCount++; // Increment the verify count
          }
        });

        // console.log('Total verified ECG values:', verifyCount);
        // console.log('Total count:', totalLength);

        if (totalLength > 0) {
          // console.log('ECG data is available.');

          // Calculate and log the percentage of verified ECG values
          const percentageVerified = (verifyCount / totalLength) * 100;
          // console.log('Percentage of verified ECG values:', percentageVerified.toFixed(2) + '%');
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
          // console.log('verified percentage:',this.state.percentageVerified)
        } else {
          // console.log('No ECG data found.');
        }
      })
      .catch((error) => {
        console.error("Error fetching ECG data:", error);
      });
  }
  // Get paginated data for the current page
  // Server-side pagination — what the server returned IS the page.
  // Apply the in-page search/filter on top so search still narrows
  // the current page client-side without an extra round-trip.
  // SERVER-side paging: the loaded `data` IS the current page (200 rows max),
  // already filtered by status + search on the server. Page bounds and the
  // record total come from the server's pagination object in state. Only the
  // purely-local filters (date range, sales partner) still apply here.
  getPageInfo = () => {
    const filtered = this.getFilteredData();
    return {
      filtered,
      perPage: this.state.itemsPerPage || 50,
      totalPages: this.state.totalPages || 1,
      currentPage: Math.max(1, this.state.currentPage || 1),
      totalRecords: this.state.totalRecords != null ? this.state.totalRecords : filtered.length,
    };
  };

  // No slicing — the server already sent exactly one page.
  getPaginatedData = () => this.getFilteredData();

  handlePageChange = (pageNumber) => {
    this.goToPage(pageNumber);
  };

  handleNextPage = () => {
    if (this.state.hasNextPage) this.goToPage((this.state.currentPage || 1) + 1);
  };

  handlePrevPage = () => {
    if (this.state.hasPrevPage) this.goToPage((this.state.currentPage || 1) - 1);
  };
  handleDoctorChange = (selectedOption) => {
    this.setState({ selectedDoctor: selectedOption });
    // console.log("Selected doctor:", selectedOption);
    // Perform any action needed with the selected doctor
  };
  // Date range is a SERVER filter now — refetch from page 1 rather than
  // narrowing the rows already loaded (which would only ever filter one page).
  handleStartDateChange = (date) => {
    this.setState({ startDate: date, currentPage: 1 }, () => this.fetchData(1));
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: date, currentPage: 1 }, () => this.fetchData(1));
  };
  getMaxDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Returns today's date in YYYY-MM-DD format
  };

  getMinDate = () => {
    const today = new Date();
    today.setMonth(today.getMonth() - 3); // Go back 3 months
    return today.toISOString().split("T")[0]; // Returns min date in YYYY-MM-DD format
  };

  // Log the partner out. Reuses the shared helper so the JWT is cleared,
  // axios auth header is reset, and the user is redirected to /login —
  // identical to logouts triggered from other pages.
  handleLogout = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    await performLogout();
  };

  // Device history — the shared popup does the fetch + rendering; this only
  // guards the click when the row has no MAC to look up.
  openDeviceHistory = (row) => {
    if (!row || !String(row.macId || "").trim()) {
      toast.error("No MAC id on this patient — device history unavailable.");
      return;
    }
    this.setState({ historyRow: row });
  };

  // Device status + remote-control popup — mirrors the telemetry dashboard.
  renderDevicePopup() {
    const d = this.state.devDetail;
    if (!d) return null;
    const label = String(d.device_id || d.user_id || "—");
    const cmds = this.state.devCommands;
    const busy = this.state.devBusy;

    const fmtTs = (ms) => {
      if (!ms) return "—";
      try { return new Date(ms).toLocaleString(); } catch (e) { return String(ms); }
    };
    const rowS = { display: "flex", justifyContent: "space-between", padding: "5px 0", fontSize: 13, borderBottom: "1px solid #17242a" };
    const keyS = { color: "#8ba3ad" };
    const btnMini = {
      padding: "6px 12px", fontSize: 12, fontWeight: 700,
      background: "rgba(90,200,250,0.12)", border: "1px solid #2a5a62",
      borderRadius: 6, color: "#5ac8fa", cursor: "pointer",
    };

    const recActive = Number(d.recording_status) === 1 || d.recording === true;
    const bleOn = d.ble_connected === true;

    return (
      <div
        onClick={this.closeDevicePopup}
        style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ background: "#101418", border: "1px solid #2a2f36", borderRadius: 12, padding: "20px 24px", width: 600, maxWidth: "94vw", maxHeight: "85vh", overflowY: "auto", overflowX: "hidden", color: "#e8eaed" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <div style={{ fontSize: 17, fontWeight: 700, color: "#5ac8fa" }}>
              Patient {label}{d.name ? " · " + d.name : ""}
            </div>
            <button onClick={this.closeDevicePopup} style={{ background: "none", border: "none", color: "#8e8e93", fontSize: 18, cursor: "pointer" }}>✕</button>
          </div>

          <div style={rowS}><span style={keyS}>Device serial</span><span style={{ fontFamily: "ui-monospace, monospace", fontSize: 15, fontWeight: 700, color: "#7fd8e5" }}>{d.serial_no || "—"}</span></div>
          <div style={rowS}><span style={keyS}>Last seen</span><span>{fmtTs(d.last_seen_ms)}</span></div>
          <div style={rowS}><span style={keyS}>Battery</span><span>
            {d.battery_pct != null && !(Number(d.battery_pct) === 0 && Number(d.recording_status) !== 1)
              ? d.battery_pct + "%"
              : "— (no reading — wearable not connected)"}
          </span></div>
          <div style={rowS}><span style={keyS}>Mobile battery</span><span>{d.mobile_battery_pct != null ? d.mobile_battery_pct + "%" : "—"}</span></div>
          <div style={rowS}><span style={keyS}>Lead (attached)</span><span>{d.device_attached == null ? "—" : d.device_attached ? "on" : "off"}</span></div>
          <div style={rowS}><span style={keyS}>Recording</span><span>
            {Number(d.recording_status) === 1 ? "recording"
              : Number(d.recording_status) === 3 ? "uploading"
              : Number(d.recording_status) === 0 ? "not recording" : "—"}
          </span></div>
          <div style={rowS}><span style={keyS}>Monitoring mode</span><span style={{ fontWeight: 700, color: d.app_mode === "remote" ? "#5ac8fa" : d.app_mode === "standalone" ? "#c8a94a" : "#8ba3ad" }}>
            {d.app_mode === "remote" ? "Remote Monitoring" : d.app_mode === "standalone" ? "Standalone" : "—"}
          </span></div>
          <div style={rowS}><span style={keyS}>BLE connected</span><span>{d.ble_connected == null ? "—" : d.ble_connected ? "yes" : "no"}</span></div>
          <div style={rowS}><span style={keyS}>Pending ECG</span><span>{d.pending_ecg != null ? d.pending_ecg : "—"}</span></div>
          <div style={{ ...rowS, borderBottom: "none" }}><span style={keyS}>Last upload</span><span>{fmtTs(d.last_upload_ms)}</span></div>

          {/* Monitoring mode — two-state control. Sends mode_remote /
              mode_standalone through the same command endpoint. "Standalone"
              is disabled while the wearable is recording (mirrors the app +
              server rule); the hint tells the user to stop monitoring first. */}
          <div style={{ margin: "16px 0 6px" }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#8e8e93", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Monitoring mode</div>
            <div style={{ display: "flex", gap: 8 }}>
              {[
                ["mode_standalone", "Standalone", "standalone"],
                ["mode_remote", "Remote Monitoring", "remote"],
              ].map(([cmd, lbl, modeVal]) => {
                const isActive = d.app_mode === modeVal;
                const recBlocked = modeVal === "standalone" && recActive;
                return (
                  <button
                    key={cmd}
                    disabled={busy === label + ":" + cmd || recBlocked || isActive}
                    title={recBlocked ? "Stop monitoring first" : isActive ? "Already in this mode" : undefined}
                    style={{
                      ...btnMini, flex: 1,
                      ...(isActive
                        ? { background: "rgba(90,200,250,0.22)", borderColor: "#5ac8fa", color: "#bfe9fb" }
                        : {}),
                      ...(recBlocked ? { opacity: 0.4, cursor: "not-allowed" } : {}),
                    }}
                    onClick={() => this.sendDeviceCommand(cmd)}
                  >
                    {isActive ? "● " + lbl : lbl}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Control commands */}
          <div style={{ display: "flex", gap: 8, margin: "16px 0 6px", flexWrap: "wrap" }}>
            {[
              ["start_recording", "▶ Start rec", false, null],
              ["stop_recording", "⏹ Stop rec", false, null],
              ["sync_now", "Sync now", false, null],
              ["connect", "Connect", false, null],
              ["disconnect", "Disconnect", false, null],
              ["poll", "Poll", false, null],
              ["clear_memory", "Clear memory", true, null],
              ["deactivate", "Deactivate", true, { mode: "factory_reset" }],
            ].map(([cmd, lbl, danger, params]) => {
              const blocked = danger && (!bleOn || recActive);
              return (
                <button
                  key={cmd}
                  disabled={busy === label + ":" + cmd || blocked}
                  title={blocked ? (!bleOn ? "Device not connected over BLE — send Connect first" : "Recording is active — stop recording first") : undefined}
                  style={{
                    ...(danger
                      ? { ...btnMini, color: "#ff9a94", borderColor: "#5a2a2a", background: "rgba(255,69,58,0.08)" }
                      : btnMini),
                    ...(blocked ? { opacity: 0.4, cursor: "not-allowed" } : {}),
                  }}
                  onClick={() => {
                    if (danger) {
                      const warn = cmd === "deactivate"
                        ? 'Send "Deactivate (factory reset)" to patient ' + label + "? IRREVERSIBLE — the device may not re-pair until an admin reactivates it."
                        : 'Send "Clear memory" to patient ' + label + "? The device memory will be wiped permanently.";
                      if (!window.confirm(warn)) return;
                    }
                    this.sendDeviceCommand(cmd, params);
                  }}
                >
                  {lbl}
                </button>
              );
            })}
          </div>
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            <input
              value={this.state.devCustom}
              onChange={(e) => this.setState({ devCustom: e.target.value })}
              placeholder="custom command…"
              style={{ flex: 1, padding: "7px 10px", background: "#0b0e11", border: "1px solid #2a2f36", borderRadius: 6, color: "#e8eaed", fontSize: 12 }}
            />
            <button style={btnMini} onClick={() => this.sendDeviceCommand(this.state.devCustom)}>Send</button>
          </div>

          <div style={{ fontSize: 12, fontWeight: 700, color: "#8e8e93", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Recent commands</div>
          {cmds == null ? (
            <div style={{ fontSize: 12, color: "#8e8e93" }}>Loading…</div>
          ) : !cmds.length ? (
            <div style={{ fontSize: 12, color: "#8e8e93" }}>No commands yet (or command routes not deployed).</div>
          ) : (
            <table style={{ fontSize: 11, width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ color: "#8ba3ad", textAlign: "left" }}>
                  <th style={{ padding: "4px 6px" }}>Command</th><th style={{ padding: "4px 6px" }}>Status</th><th style={{ padding: "4px 6px" }}>Detail</th><th style={{ padding: "4px 6px" }}>Delivery</th><th style={{ padding: "4px 6px" }}>Requested</th><th style={{ padding: "4px 6px" }}>Done</th>
                </tr>
              </thead>
              <tbody>
                {cmds.map((c, i) => (
                  <tr key={i} style={{ borderTop: "1px solid #17242a" }}>
                    <td style={{ padding: "4px 6px" }}>{c.command}{c.mode ? " (" + c.mode + ")" : ""}</td>
                    <td style={{ padding: "4px 6px", fontWeight: 600, color: c.status === "executed" ? "#30d158" : c.status === "failed" ? "#ff453a" : "#ff9f0a" }}>{c.status}</td>
                    <td style={{ padding: "4px 6px", color: "#8ba3ad" }}>{c.detail || c.result || "—"}</td>
                    <td style={{ padding: "4px 6px", color: c.delivery === "pushed" ? "#30d158" : c.delivery === "no_token" ? "#ff9f0a" : c.delivery === "push_failed" ? "#ff453a" : "#8e8e93" }}>{c.delivery || "—"}</td>
                    <td style={{ padding: "4px 6px" }}>{fmtTs(c.requested_ms || (c.createdAt && new Date(c.createdAt).getTime()))}</td>
                    <td style={{ padding: "4px 6px" }}>{c.executed_ms ? fmtTs(c.executed_ms) : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { errors, doctors, selectedDoctor } = this.state;
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    const paginatedData = this.getPaginatedData();
    // Server-side pagination: page bounds and the record total come from the
    // server's pagination object (via getPageInfo).
    const { filtered: filteredData, totalPages, currentPage, totalRecords } = this.getPageInfo();
    const { sortColumn, sortDirection, maxPageButtons } = this.state;

    // Create page buttons
    const pageButtons = [];
    for (let i = 1; i <= totalPages; i++) {
      pageButtons.push(i);
    }

    // Calculate visible page buttons (only show `maxPageButtons` at a time)
    const startIndex = Math.max(
      0,
      currentPage - Math.floor(maxPageButtons / 2) - 1
    );
    const endIndex = Math.min(pageButtons.length, startIndex + maxPageButtons);
    const visiblePageButtons = pageButtons.slice(startIndex, endIndex);

    return (
      <div style={{ background: "#ffffff", minHeight: "100vh" }}>
        <Toaster position="top-right" reverseOrder={false} />

        {/* ── Request FD dialog: where should the Full Disclosure report be sent? ── */}
        {this.state.fdTarget && (
          <div
            onClick={this.state.fdBusy ? undefined : this.closeFdDialog}
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              role="dialog"
              aria-modal="true"
              aria-label="Request Full Disclosure report"
              style={{ background: "#fff", borderRadius: "10px", padding: "20px 22px", width: "440px", maxWidth: "92vw", boxShadow: "0 12px 40px rgba(0,0,0,0.25)", fontSize: "13px", color: "#1f2933" }}
            >
              <div style={{ fontSize: "15px", fontWeight: 700, marginBottom: "4px" }}>Request Full Disclosure (FD)</div>
              <div style={{ color: "#5b6770", marginBottom: "14px" }}>
                {this.state.fdTarget.name} · {this.state.fdTarget.patientId}
              </div>

              {(() => {
                const last = (this.state.fdRequests || {})[this.state.fdTarget.userid];
                if (!last) return null;
                return (
                  <div style={{ background: "#f4f7f9", border: "1px solid #dde3e8", borderRadius: "6px", padding: "8px 10px", marginBottom: "12px", fontSize: "12px", color: "#3e4c59" }}>
                    Already requested {last.count > 1 ? `${last.count} times — last ` : ""}on{" "}
                    {new Date(last.requestedAt).toLocaleString()} → {(last.emails || []).join(", ")} ({last.status}).
                    Sending this creates a new request.
                  </div>
                );
              })()}

              <label htmlFor="fd-emails" style={{ display: "block", fontWeight: 600, marginBottom: "6px" }}>
                Send the FD to (e-mail)
              </label>
              <input
                id="fd-emails"
                type="text"
                inputMode="email"
                autoFocus
                placeholder="doctor@hospital.com, reports@clinic.com"
                value={this.state.fdEmails}
                onChange={(e) => this.setState({ fdEmails: e.target.value, fdError: "" })}
                onKeyDown={(e) => { if (e.key === "Enter") this.submitFd(); if (e.key === "Escape" && !this.state.fdBusy) this.closeFdDialog(); }}
                style={{ width: "100%", padding: "8px 10px", fontSize: "14px", border: "1px solid #b9c6d1", borderRadius: "6px", boxSizing: "border-box" }}
              />
              <div style={{ color: "#5b6770", fontSize: "11px", marginTop: "6px" }}>
                Up to 5 addresses, separated by commas.
              </div>

              <label htmlFor="fd-note" style={{ display: "block", fontWeight: 600, margin: "12px 0 6px" }}>
                Note <span style={{ fontWeight: 400, color: "#5b6770" }}>(optional)</span>
              </label>
              <input
                id="fd-note"
                type="text"
                maxLength={300}
                placeholder="e.g. needed for cardiology review on Monday"
                value={this.state.fdNote}
                onChange={(e) => this.setState({ fdNote: e.target.value })}
                onKeyDown={(e) => { if (e.key === "Enter") this.submitFd(); if (e.key === "Escape" && !this.state.fdBusy) this.closeFdDialog(); }}
                style={{ width: "100%", padding: "8px 10px", fontSize: "13px", border: "1px solid #b9c6d1", borderRadius: "6px", boxSizing: "border-box" }}
              />

              {this.state.fdError && (
                <div role="alert" style={{ color: "#c62828", marginTop: "10px", fontWeight: 600 }}>{this.state.fdError}</div>
              )}

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "18px" }}>
                <button
                  type="button"
                  onClick={this.closeFdDialog}
                  disabled={this.state.fdBusy}
                  style={{ padding: "7px 14px", fontSize: "13px", background: "#f1f4f7", border: "1px solid #c9d3dc", borderRadius: "6px", cursor: "pointer" }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={this.submitFd}
                  disabled={this.state.fdBusy}
                  style={{ padding: "7px 16px", fontSize: "13px", background: "#0a8aa0", border: "1px solid #0a8aa0", borderRadius: "6px", color: "#fff", fontWeight: 700, cursor: this.state.fdBusy ? "default" : "pointer", opacity: this.state.fdBusy ? 0.7 : 1 }}
                >
                  {this.state.fdBusy ? "Sending…" : "Request FD"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Confirm dialog: review/adjust monitoring duration, then confirm ── */}
        {this.state.confirmTarget && (
          <div
            onClick={this.closeConfirmDialog}
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              role="dialog"
              aria-modal="true"
              style={{ background: "#fff", borderRadius: "10px", padding: "20px 22px", width: "380px", maxWidth: "92vw", boxShadow: "0 12px 40px rgba(0,0,0,0.25)", fontSize: "13px", color: "#1d2a35" }}
            >
              <div style={{ fontSize: "15px", fontWeight: 700, marginBottom: "4px" }}>Confirm uploaded data</div>
              <div style={{ color: "#5b6770", marginBottom: "14px" }}>
                {this.state.confirmTarget.name} · {this.state.confirmTarget.patientId}
              </div>

              <label style={{ display: "block", fontWeight: 600, marginBottom: "6px" }}>
                Monitoring duration (days)
              </label>
              <input
                type="number"
                min="1"
                max="90"
                step="1"
                autoFocus
                value={this.state.confirmDays}
                onChange={(e) => this.setState({ confirmDays: e.target.value, confirmError: "" })}
                onKeyDown={(e) => { if (e.key === "Enter") this.submitConfirm(); if (e.key === "Escape") this.closeConfirmDialog(); }}
                style={{ width: "100%", padding: "8px 10px", fontSize: "14px", border: "1px solid #b9c6d1", borderRadius: "6px", boxSizing: "border-box" }}
              />
              <div style={{ color: "#5b6770", fontSize: "11px", marginTop: "6px" }}>
                Pre-filled with the current duration — change it here if the plan is different.
              </div>

              {this.state.confirmError && (
                <div style={{ color: "#c62828", marginTop: "10px", fontWeight: 600 }}>{this.state.confirmError}</div>
              )}

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "18px" }}>
                <button
                  type="button"
                  onClick={this.closeConfirmDialog}
                  disabled={this.state.confirmBusy}
                  style={{ padding: "7px 14px", fontSize: "13px", background: "#f1f4f7", border: "1px solid #c9d3dc", borderRadius: "6px", cursor: "pointer" }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={this.submitConfirm}
                  disabled={this.state.confirmBusy}
                  style={{ padding: "7px 16px", fontSize: "13px", background: "#1f7a3a", border: "1px solid #1f7a3a", borderRadius: "6px", color: "#fff", fontWeight: 700, cursor: "pointer", opacity: this.state.confirmBusy ? 0.7 : 1 }}
                >
                  {this.state.confirmBusy ? "Confirming…" : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        )}

        <SideBar menus={this.state.menus} stickyLayout={true} topOffset={0} />

        {/* ── Sticky top bar — always-visible Refresh + Logout + identity.
            Sits above the page content. Works on mobile because it
            doesn't depend on the overlay sidebar to be expanded. */}
        <div className="dp-topbar" style={{
          position: "sticky", top: 0, zIndex: 600,
          display: "flex", alignItems: "center", justifyContent: "space-between",
          gap: 10,
          padding: "10px 16px",
          background: "rgba(255,255,255,0.97)",
          borderBottom: "1px solid rgba(10,138,160,0.12)",
          backdropFilter: "blur(6px)",
        }}>
          <div style={{
            display: "flex", alignItems: "center", gap: 10,
            minWidth: 0, flex: 1,
          }}>
            <div style={{
              width: 32, height: 32, borderRadius: 8,
              background: "linear-gradient(135deg,#0a8aa0,#076575)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, fontWeight: 700, color: "#fff", flexShrink: 0,
            }}>
              {(localStorage.getItem("verifiername") || "P").charAt(0).toUpperCase()}
            </div>
            <div style={{ overflow: "hidden", minWidth: 0 }}>
              <div style={{
                color: "#1f2933", fontSize: 14, fontWeight: 700,
                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
              }}>
                {localStorage.getItem("verifiername") || "Partner"}
              </div>
              <div style={{ color: "#5b6770", fontSize: 10, marginTop: 1 }}>
                Partner Dashboard
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
            <button
              onClick={() => this.fetchData()}
              title="Reload patient list"
              style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                padding: "8px 14px",
                minHeight: 36, minWidth: 40,
                background: "transparent",
                border: "1px solid rgba(10,138,160,0.3)",
                color: "#0a8aa0",
                borderRadius: 8,
                fontSize: 13, fontWeight: 600,
                cursor: "pointer",
              }}
            >
              <span style={{ fontSize: 14 }}>↻</span>
              <span className="dp-logout-label">Refresh</span>
            </button>
            <button
              onClick={this.handleLogout}
              title="Sign out"
              style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                padding: "8px 14px",
                minHeight: 36, minWidth: 40,
                background: "rgba(201,42,42,0.08)",
                border: "1px solid rgba(201,42,42,0.3)",
                color: "#c92a2a",
                borderRadius: 8,
                fontSize: 13, fontWeight: 600,
                cursor: "pointer",
              }}
            >
              <span style={{ fontSize: 14 }}>🚪</span>
              <span className="dp-logout-label">Logout</span>
            </button>
          </div>
        </div>

        <div style={{ background: "#ffffff", minHeight: "100vh", paddingTop: "10px" }}>
        <div id="editInfoModal" className="modal fade" role="dialog">
          <div className="modal-dialog" style={{ maxWidth: 580, margin: "40px auto", width: "90%" }}>
            <div className="modal-content" style={{ borderRadius: 12, overflow: "hidden", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.5)", background: "#ffffff" }}>

              {/* Header */}
              <div style={{ background: "#f4f7f9", padding: "16px 22px", borderBottom: "1px solid #dde3e8", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                  <div style={{ color: "#0a8aa0", fontWeight: 700, fontSize: "16px" }}>Edit Patient Information</div>
                  {this.state.patient_name && (
                    <div style={{ color: "#5b6770", fontSize: "12px", marginTop: 2 }}>{this.state.patient_name}</div>
                  )}
                </div>
                <button type="button" data-dismiss="modal" className="closePopup"
                  style={{ background: "rgba(10,138,160,0.10)", border: "1px solid #cdd7df", color: "#0a8aa0", width: 30, height: 30, borderRadius: "50%", fontSize: "16px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1 }}>
                  ×
                </button>
              </div>

              <form method="post" onSubmit={this.onSubmitInfo}>
                <div style={{ padding: "20px 22px", position: "relative" }}>

                  {/* Loading overlay */}
                  {this.state.loadingEditModal && (
                    <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(255,255,255,0.85)", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 8 }}>
                      <div style={{ width: 40, height: 40, border: "4px solid #dde3e8", borderTop: "4px solid #0a8aa0", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
                      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                    </div>
                  )}

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>

                    {/* Name */}
                    <div>
                      <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>Name</label>
                      <input type="text" name="patient_name"
                        onChange={(e) => this.setState({ patient_name: e.target.value })}
                        value={this.state.patient_name}
                        style={{ width: "100%", padding: "9px 12px", background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 7, color: "#1f2933", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
                    </div>

                    {/* Email */}
                    <div>
                      <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>Email</label>
                      <input type="text" name="email_id"
                        onChange={(e) => this.setState({ email_id: e.target.value })}
                        value={this.state.email_id}
                        style={{ width: "100%", padding: "9px 12px", background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 7, color: "#1f2933", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
                    </div>

                    {/* Doctor Name */}
                    <div>
                      <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>Doctor Name</label>
                      <Select
                        options={options}
                        value={selectedDoctor}
                        onChange={this.handleDoctorChange}
                        placeholder="Search Doctor"
                        classNamePrefix="react-select"
                        styles={{
                          control: (base) => ({ ...base, background: "#f4f7f9", borderColor: "#cdd7df", borderRadius: 7, minHeight: 38, boxShadow: "none", "&:hover": { borderColor: "#0a8aa0" } }),
                          menu: (base) => ({ ...base, background: "#ffffff", border: "1px solid #cdd7df", zIndex: 9999 }),
                          option: (base, { isFocused }) => ({ ...base, background: isFocused ? "#cdd7df" : "#ffffff", color: "#1f2933", fontSize: 13 }),
                          singleValue: (base) => ({ ...base, color: "#1f2933", fontSize: 13 }),
                          input: (base) => ({ ...base, color: "#1f2933" }),
                          placeholder: (base) => ({ ...base, color: "#5b6770", fontSize: 13 }),
                          dropdownIndicator: (base) => ({ ...base, color: "#0a8aa0" }),
                          indicatorSeparator: () => ({ display: "none" }),
                        }}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>Phone Number</label>
                      <input type="text" name="Phone-number"
                        onChange={(e) => this.setState({ Phonenumber: e.target.value })}
                        value={this.state.Phonenumber}
                        style={{ width: "100%", padding: "9px 12px", background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 7, color: "#1f2933", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
                    </div>

                    {/* Monitoring Duration */}
                    <div>
                      <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>Monitoring Duration</label>
                      <input type="text" name="MonitoringDuration"
                        onChange={(e) => this.setState({ duration: e.target.value })}
                        value={this.state.duration}
                        style={{ width: "100%", padding: "9px 12px", background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 7, color: "#1f2933", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
                    </div>

                    {/* Gender */}
                    <div>
                      <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>Gender</label>
                      <select name="Gender"
                        onChange={(e) => this.setState({ gender: e.target.value })}
                        value={this.state.gender}
                        style={{ width: "100%", padding: "9px 12px", background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 7, color: "#1f2933", fontSize: "13px", outline: "none", boxSizing: "border-box" }}>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                      </select>
                    </div>

                    {/* Hospital Name */}
                    <div>
                      <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>Hospital Name</label>
                      <input type="text" name="HospitalName"
                        onChange={(e) => this.setState({ hospital: e.target.value })}
                        value={this.state.hospital}
                        style={{ width: "100%", padding: "9px 12px", background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 7, color: "#1f2933", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
                    </div>

                    {/* IP/OP */}
                    <div>
                      <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>IP / OP</label>
                      <input type="text" name="ipop"
                        onChange={(e) => this.setState({ ipop: e.target.value })}
                        value={this.state.ipop}
                        style={{ width: "100%", padding: "9px 12px", background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 7, color: "#1f2933", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
                    </div>

                    {/* Pacemaker (stored in hyper_lipidemia) */}
                    <div>
                      <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>Pacemaker</label>
                      <div style={{ display: "flex" }}>
                        {[true, false].map((v) => (
                          <button
                            key={String(v)}
                            type="button"
                            onClick={() => this.setState({ pacemaker: v })}
                            style={{
                              flex: 1,
                              padding: "9px 0",
                              fontSize: "13px",
                              fontWeight: 600,
                              border: "1px solid #cdd7df",
                              background: this.state.pacemaker === v ? (v ? "#e74c3c" : "#27ae60") : "#f4f7f9",
                              color: this.state.pacemaker === v ? "#fff" : "#5b6770",
                              cursor: "pointer",
                              borderRadius: v ? "7px 0 0 7px" : "0 7px 7px 0",
                            }}
                          >
                            {v ? "Yes" : "No"}
                          </button>
                        ))}
                      </div>
                    </div>

                  </div>
                </div>

                {/* Footer */}
                <div style={{ padding: "14px 22px", borderTop: "1px solid #dde3e8", display: "flex", justifyContent: "flex-end", gap: 10, background: "#f4f7f9" }}>
                  <button type="button" data-dismiss="modal" className="closePopup"
                    style={{ padding: "8px 22px", fontSize: "13px", background: "transparent", border: "1px solid #cdd7df", borderRadius: 7, color: "#5b6770", cursor: "pointer", fontWeight: 500 }}>
                    Cancel
                  </button>
                  <button type="submit" disabled={this.state.loadingEditModal}
                    style={{ padding: "8px 26px", fontSize: "13px", background: this.state.loadingEditModal ? "#cdd7df" : "#0a8aa0", border: "none", borderRadius: 7, color: "#f4f7f9", fontWeight: 700, cursor: this.state.loadingEditModal ? "not-allowed" : "pointer" }}>
                    {this.state.loadingEditModal ? "Saving…" : "Save Changes"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div id="remarkmodal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <h4 className="modal-title text-center">Remarks</h4>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  
                  axios
                    .post(`${apiUrl}api/common/updateRemarks`, {
                      userid: this.state.user_id,
                      remarks: this.state.remarks,
                      
                    })
                    .then((res) => {
                      // Close via this modal's own dismiss button —
                      // Bootstrap's handler lives on the page's global
                      // jQuery, so $(...).modal() isn't available here.
                      const closeBtn = document.querySelector(
                        "#remarkmodal [data-dismiss='modal']"
                      );
                      if (closeBtn) closeBtn.click();
                      this.fetchData(); // Fetch updated data
                    })
                    .catch((err) => {
                     // Handle any errors from either request
                     console.error("Error occurred:", err);
                    });
                }}
              >
                <div  className="modal-body">
                  <div className="form-group">
                    <label
                      className="form-control-label mbr-fonts-style display-7"
                      style={{ color: "Black" }}
                    >
                      Remarks:
                    </label>
                    <textarea
                      className="form-control"
                      rows="4"
                      placeholder="Enter remarks..."
                      onChange={(e) =>
                        this.setState({ remarks: e.target.value })
                      }
                      value={this.state.remarks}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="submit"
                    className="btn btn-success  "
                    
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Assign Sales Partner Modal */}
        <div id="salespartnermodal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <h4 className="modal-title text-center">Sales Partner</h4>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const resolve = (sel, inp) =>
                    sel === "__new" ? (inp || "").trim() : String(sel || "").trim();
                  const chosen = resolve(this.state.salesPartnerSelect, this.state.salesPartnerInput);
                  const chosen2 = resolve(this.state.salesPartnerSelect2, this.state.salesPartnerInput2);
                  if (this.state.salesPartnerSelect === "__new" && !chosen) {
                    alert("Enter the first sales partner's name");
                    return;
                  }
                  if (this.state.salesPartnerSelect2 === "__new" && !chosen2) {
                    alert("Enter the second sales partner's name");
                    return;
                  }
                  if (chosen2 && chosen2 === chosen) {
                    alert("The two sales partners must be different.");
                    return;
                  }
                  axios
                    .post(`${apiUrl}api/common/updateSalesPartner`, {
                      userid: this.state.user_id,
                      salesPartner: chosen,
                      salesPartner2: chosen2,
                    })
                    .then(() => {
                      // Close via the modal's own dismiss button — Bootstrap's
                      // handler is bound to the page's global jQuery, not the
                      // webpack-imported one, so $(...).modal() isn't available.
                      const closeBtn = document.querySelector(
                        "#salespartnermodal [data-dismiss='modal']"
                      );
                      if (closeBtn) closeBtn.click();
                      this.fetchData();
                    })
                    .catch((err) => {
                      console.error("Error saving sales partner:", err);
                      alert(
                        "Could not save: " +
                          ((err.response && err.response.status) || err.message) +
                          ". Check the updateSalesPartner backend route."
                      );
                    });
                }}
              >
                <div className="modal-body">
                  <div className="form-group">
                    <label
                      className="form-control-label mbr-fonts-style display-7"
                      style={{ color: "Black" }}
                    >
                      Sales partner:
                    </label>
                    <select
                      className="form-control"
                      value={this.state.salesPartnerSelect}
                      onChange={(e) =>
                        this.setState({ salesPartnerSelect: e.target.value })
                      }
                    >
                      <option value="">— No sales partner —</option>
                      {[
                        ...new Set(
                          (this.state.data || [])
                            .map((p) => String(p.salesPartner || "").trim())
                            .filter(Boolean)
                        ),
                      ]
                        .sort()
                        .map((sp) => (
                          <option key={sp} value={sp}>
                            {sp}
                          </option>
                        ))}
                      <option value="__new">+ Add new sales partner…</option>
                    </select>
                    {this.state.salesPartnerSelect === "__new" && (
                      <input
                        className="form-control"
                        style={{ marginTop: 10 }}
                        placeholder="New sales partner name..."
                        autoFocus
                        onChange={(e) =>
                          this.setState({ salesPartnerInput: e.target.value })
                        }
                        value={this.state.salesPartnerInput}
                      />
                    )}
                  </div>

                  {/* Second sales partner (optional) */}
                  <div className="form-group">
                    <label
                      className="form-control-label mbr-fonts-style display-7"
                      style={{ color: "Black" }}
                    >
                      Second sales partner (optional):
                    </label>
                    <select
                      className="form-control"
                      value={this.state.salesPartnerSelect2}
                      onChange={(e) =>
                        this.setState({ salesPartnerSelect2: e.target.value })
                      }
                    >
                      <option value="">— None —</option>
                      {[
                        ...new Set(
                          (this.state.data || [])
                            .flatMap((p) => [p.salesPartner, p.salesPartner2])
                            .map((s) => String(s || "").trim())
                            .filter(Boolean)
                        ),
                      ]
                        .sort()
                        .map((sp) => (
                          <option key={sp} value={sp}>
                            {sp}
                          </option>
                        ))}
                      <option value="__new">+ Add new sales partner…</option>
                    </select>
                    {this.state.salesPartnerSelect2 === "__new" && (
                      <input
                        className="form-control"
                        style={{ marginTop: 10 }}
                        placeholder="Second sales partner name..."
                        onChange={(e) =>
                          this.setState({ salesPartnerInput2: e.target.value })
                        }
                        value={this.state.salesPartnerInput2}
                      />
                    )}
                    <div style={{ fontSize: "11px", color: "#5b6770", marginTop: 6 }}>
                      Assign one or two partners. Set the first to "— No sales partner —" to clear.
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-success">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Share Report Modal */}
        <div id="mailinfomodal" className="modal fade" role="dialog" aria-hidden="true">
          <div className="modal-dialog" style={{ maxWidth: 480, margin: "60px auto", width: "90%" }}>
            <div className="modal-content" style={{ borderRadius: 12, overflow: "hidden", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.5)", background: "#ffffff" }}>

              {/* Header */}
              <div style={{ background: "#f4f7f9", padding: "16px 22px", borderBottom: "1px solid #dde3e8", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#25D366" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                  </svg>
                  <div>
                    <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px" }}>Share Report</div>
                    <div style={{ color: "#5b6770", fontSize: "11px", marginTop: 1 }}>Send via WhatsApp</div>
                  </div>
                </div>
                <button type="button" data-dismiss="modal" onClick={this.clearShareReportState}
                  style={{ background: "rgba(10,138,160,0.10)", border: "1px solid #cdd7df", color: "#0a8aa0", width: 30, height: 30, borderRadius: "50%", fontSize: "16px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  ×
                </button>
              </div>

              {/* Body */}
              <div style={{ padding: "22px 22px 10px" }}>
                <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>
                  Patient WhatsApp Number
                </label>
                <div style={{ display: "flex", alignItems: "center", gap: 10, background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 8, padding: "0 12px" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#25D366" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                  </svg>
                  <input
                    type="tel"
                    value={this.state.patientwhatsappNumber}
                    onChange={(e) => this.setState({ patientwhatsappNumber: e.target.value })}
                    placeholder="e.g. 9876543210"
                    style={{ flex: 1, padding: "11px 0", background: "transparent", border: "none", color: "#1f2933", fontSize: "14px", outline: "none" }}
                  />
                </div>
                <div style={{ color: "#5b6770", fontSize: "11px", marginTop: 6 }}>
                  The report will be delivered to this number via WhatsApp.
                </div>
              </div>

              {/* Footer */}
              <div style={{ padding: "14px 22px 20px", display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <button type="button" data-dismiss="modal" onClick={this.clearShareReportState}
                  style={{ padding: "8px 20px", fontSize: "13px", background: "transparent", border: "1px solid #cdd7df", borderRadius: 7, color: "#5b6770", cursor: "pointer", fontWeight: 500 }}>
                  Cancel
                </button>
                <button type="button" data-dismiss="modal"
                  onClick={() => this.sentWhatsappReportPatient()}
                  style={{ padding: "8px 22px", fontSize: "13px", background: "#25D366", border: "none", borderRadius: 7, color: "#fff", fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                  </svg>
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* WhatsApp Distributor Modal */}
        <div id="whatsappinfomodal" className="modal fade" role="dialog" aria-hidden="true">
          <div className="modal-dialog" style={{ maxWidth: 480, margin: "60px auto", width: "90%" }}>
            <div className="modal-content" style={{ borderRadius: 12, overflow: "hidden", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.5)", background: "#ffffff" }}>

              <div style={{ background: "#f4f7f9", padding: "16px 22px", borderBottom: "1px solid #dde3e8", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px" }}>Share Report via WhatsApp</div>
                <button type="button" data-dismiss="modal"
                  style={{ background: "rgba(10,138,160,0.10)", border: "1px solid #cdd7df", color: "#0a8aa0", width: 30, height: 30, borderRadius: "50%", fontSize: "16px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  ×
                </button>
              </div>

              <div style={{ padding: "22px 22px 10px", display: "flex", flexDirection: "column", gap: 14 }}>
                <div>
                  <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>WhatsApp Number</label>
                  <input
                    value={this.state.whatsappNumber || ""}
                    onChange={(e) => this.setState({ whatsappNumber: e.target.value })}
                    placeholder="Enter WhatsApp number..."
                    style={{ width: "100%", padding: "9px 12px", background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 7, color: "#1f2933", fontSize: "13px", outline: "none", boxSizing: "border-box" }}
                  />
                </div>
                <div>
                  <label style={{ display: "block", color: "#5b6770", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>Report Subject</label>
                  <textarea
                    onChange={(e) => this.setState({ arrythymia: e.target.value })}
                    placeholder="Enter report subject here..."
                    rows={3}
                    style={{ width: "100%", padding: "9px 12px", background: "#f4f7f9", border: "1px solid #cdd7df", borderRadius: 7, color: "#1f2933", fontSize: "13px", outline: "none", resize: "none", boxSizing: "border-box" }}
                  />
                </div>
              </div>

              <div style={{ padding: "14px 22px 20px", display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <button type="button" data-dismiss="modal" className="closePopup"
                  style={{ padding: "8px 20px", fontSize: "13px", background: "transparent", border: "1px solid #cdd7df", borderRadius: 7, color: "#5b6770", cursor: "pointer", fontWeight: 500 }}>
                  Cancel
                </button>
                <button id={this.state.userid} type="button" data-dismiss="modal"
                  onClick={this.sentWhatsappReport}
                  style={{ padding: "8px 22px", fontSize: "13px", background: "#25D366", border: "none", borderRadius: 7, color: "#fff", fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                  </svg>
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Search / Filter Bar */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px", padding: "16px 24px", marginTop: "20px", background: "#ffffff" }}>
          <h6 style={{ margin: 0, color: "#0a8aa0", fontWeight: 700, fontSize: "15px", letterSpacing: "0.5px" }}>
            Patient List &nbsp;<span style={{ color: "#5b6770", fontWeight: 400, fontSize: "13px" }}>({totalRecords} records{totalPages > 1 ? ` · page ${currentPage} of ${totalPages}` : ""})</span>
          </h6>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <input
              type="text"
              placeholder="Search patients..."
              value={this.state.searchTerm}
              onChange={this.handleSearchChange}
              style={{ padding: "7px 12px", width: "220px", borderRadius: "6px", border: "1px solid #cdd7df", background: "#eef2f5", fontSize: "13px", color: "#1f2933", outline: "none" }}
            />
            <input
              type="date"
              value={this.state.startDate}
              onChange={(e) => this.handleStartDateChange(e.target.value)}
              min={this.getMinDate()}
              max={this.getMaxDate()}
              style={{ padding: "7px 10px", borderRadius: "6px", border: "1px solid #cdd7df", background: "#eef2f5", fontSize: "13px", color: "#1f2933", cursor: "pointer" }}
            />
            <input
              type="date"
              value={this.state.endDate}
              onChange={(e) => this.handleEndDateChange(e.target.value)}
              min={this.getMinDate()}
              max={this.getMaxDate()}
              style={{ padding: "7px 10px", borderRadius: "6px", border: "1px solid #cdd7df", background: "#eef2f5", fontSize: "13px", color: "#1f2933", cursor: "pointer" }}
            />
            <button
              onClick={this.openAddDeviceModal}
              title="Add a patient to your dashboard by Patient ID (for patients that didn't link to your device)"
              style={{ padding: "7px 14px", background: "#0a8aa0", border: "1px solid #0a8aa0", borderRadius: "6px", color: "#ffffff", fontSize: "13px", cursor: "pointer", fontWeight: 600 }}
            >
              ＋ Add by Patient ID
            </button>
            <button
              onClick={this.handleExportToCSV}
              style={{ padding: "7px 14px", background: "#cdd7df", border: "1px solid #0a8aa0", borderRadius: "6px", color: "#1f2933", fontSize: "13px", cursor: "pointer", fontWeight: 600 }}
            >
              Export CSV
            </button>
          </div>
        </div>

        {this.renderDevicePopup()}
        <DeviceHistoryModal
          open={!!this.state.historyRow}
          macId={this.state.historyRow && this.state.historyRow.macId}
          serial={this.state.historyRow && this.state.historyRow.devicenumber}
          theme="light"
          onClose={() => this.setState({ historyRow: null })}
        />

        {/* Add patient by Device ID — centered modal */}
        {this.state.addDeviceModalOpen && (
          <div
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}
            onClick={this.closeAddDeviceModal}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{ background: "#ffffff", borderRadius: 10, width: 380, maxWidth: "92vw", boxShadow: "0 12px 40px rgba(0,0,0,0.25)", overflow: "hidden" }}
            >
              <div style={{ background: "#0c2e32", padding: "12px 18px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>＋ Add patient by Patient ID</span>
                <button onClick={this.closeAddDeviceModal} style={{ background: "none", border: "none", color: "#fff", fontSize: 18, cursor: "pointer" }}>×</button>
              </div>
              <div style={{ padding: "18px" }}>
                <p style={{ color: "#5b6770", fontSize: 12, margin: "0 0 12px" }}>
                  Enter the 6-digit Patient ID of a patient recorded on your device
                  that isn't showing here. It will be linked to your dashboard.
                </p>
                <input
                  type="text"
                  inputMode="numeric"
                  autoFocus
                  placeholder="e.g. 251677"
                  value={this.state.addDeviceId}
                  disabled={this.state.addDeviceBusy}
                  onChange={(e) => this.setState({ addDeviceId: e.target.value.replace(/[^\d]/g, "") })}
                  onKeyDown={(e) => { if (e.key === "Enter" && !this.state.addDeviceBusy) this.addPatientByDevice(false); }}
                  style={{ width: "100%", padding: "10px 12px", fontSize: 15, letterSpacing: 1, borderRadius: 7, border: "1px solid #cdd7df", background: "#f4f7f9", color: "#1f2933", outline: "none", boxSizing: "border-box" }}
                />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
                  <button
                    type="button"
                    onClick={this.closeAddDeviceModal}
                    disabled={this.state.addDeviceBusy}
                    style={{ padding: "8px 16px", fontSize: 13, background: "transparent", border: "1px solid #cdd7df", borderRadius: 7, color: "#5b6770", cursor: "pointer" }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => this.addPatientByDevice(false)}
                    disabled={this.state.addDeviceBusy}
                    style={{ padding: "8px 20px", fontSize: 13, background: this.state.addDeviceBusy ? "#7f8c8d" : "#0a8aa0", border: "none", borderRadius: 7, color: "#fff", fontWeight: 700, cursor: this.state.addDeviceBusy ? "wait" : "pointer" }}
                  >
                    {this.state.addDeviceBusy ? "Adding…" : "Add to dashboard"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Lifecycle tabs — the patient's journey through the pipeline:
              Registered       → everything in the current window
              Under Monitoring → device still out, data not yet uploaded
              Under Processing → data uploaded; verification / reporting in
                                 progress (the patients sitting in
                                 patient-list / verification-completed / QC)
              Published        → report generated and available
            Counts are computed from the loaded list so they're always
            consistent with the rows shown, whichever backend is deployed. */}
        {(() => {
          const rows = this.state.data || [];
          // Chip totals come from the server, which counts over the WHOLE
          // filtered set. Counting the loaded rows instead would show the
          // size of the current page — wrong the moment paging is on.
          // Local counts stay as the fallback for a non-paginated backend.
          const sc = this.state.statusCounts;
          const counts = sc
            ? {
                all:        sc.all        != null ? sc.all        : rows.length,
                monitoring: sc.monitoring != null ? sc.monitoring : 0,
                processing: sc.processing != null ? sc.processing : 0,
                published:  sc.published  != null ? sc.published  : 0,
              }
            : {
                all: rows.length,
                monitoring: rows.filter(
                  (p) => p.recordingStatus !== "Data Upload" && !isReportGenerated(p)
                ).length,
                processing: rows.filter(
                  (p) => p.recordingStatus === "Data Upload" && !isReportGenerated(p)
                ).length,
                published: rows.filter(isReportGenerated).length,
              };
          const chips = [
            { id: "all", label: "Registered" },
            { id: "monitoring", label: "Under Monitoring" },
            { id: "processing", label: "Under Processing" },
            { id: "published", label: "Published" },
          ];
          // Same reasoning: prefer the server's all-pages option list.
          const salesPartners = this.state.salesPartnerOptions
            ? this.state.salesPartnerOptions
            : [
                ...new Set(
                  rows
                    .map((p) => String(p.salesPartner || "").trim())
                    .filter(Boolean)
                ),
              ].sort();
          return (
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center", padding: "0 24px 12px", background: "#ffffff" }}>
              {chips.map((c) => {
                const active = (this.state.statusFilter || "all") === c.id;
                return (
                  <button
                    key={c.id}
                    onClick={() => this.setState({ statusFilter: c.id, currentPage: 1 }, () => this.fetchData(1))}
                    style={{
                      padding: "5px 14px",
                      fontSize: "12px",
                      borderRadius: "14px",
                      border: active ? "1px solid #0a8aa0" : "1px solid #cdd7df",
                      background: active ? "#0a8aa0" : "#eef2f5",
                      color: active ? "#ffffff" : "#5b6770",
                      fontWeight: active ? 700 : 500,
                      cursor: "pointer",
                    }}
                  >
                    {c.label} ({counts[c.id]})
                  </button>
                );
              })}
              {/* Per-sales-partner listing: pick a name, the table (and
                  Export CSV) show only that partner's patients */}
              <select
                value={this.state.salesPartnerFilter || "all"}
                onChange={(e) =>
                  this.setState(
                    { salesPartnerFilter: e.target.value, currentPage: 1 },
                    () => this.fetchData(1)
                  )
                }
                style={{
                  marginLeft: "auto",
                  padding: "6px 10px",
                  fontSize: "12px",
                  borderRadius: "6px",
                  border: "1px solid #cdd7df",
                  background: "#eef2f5",
                  color: "#1f2933",
                  cursor: "pointer",
                }}
              >
                <option value="all">All sales partners</option>
                <option value="__none">Unassigned</option>
                {salesPartners.map((sp) => (
                  <option key={sp} value={sp}>{sp}</option>
                ))}
              </select>
            </div>
          );
        })()}

        {/* Table */}
        <div className="dp-tbl-wrap" style={{ overflowX: "auto", padding: "0 8px 16px" }}>
          {/* The card is sized to fit its content (the table) so the OUTER
              wrapper (dp-tbl-wrap) is what scrolls sideways. With overflow:hidden
              alone the card clipped the table and nothing scrolled. The table
              carries a fixed pixel width matching its 18 declared column widths
              (see the CSS min-width) — NOT width:100%, which would circularly
              size against a fit-content parent and balloon the columns. */}
          <div style={{ background: "#f4f7f9", border: "1px solid #dde3e8", borderRadius: "10px", overflow: "hidden", display: "inline-block", minWidth: "100%" }}>
            <table style={{ width: "2160px", tableLayout: "fixed", borderCollapse: "collapse", fontSize: "11px" }}>
              <thead>
                <tr style={{ background: "#eef2f5" }}>
                  {[
                    { label: "SL NO", key: "slno", w: "40px" },
                    { label: "PATIENT ID / NAME", key: "patientId", w: "180px" },
                    { label: "CREATED DATE / DURATION", key: "createdDate", w: "150px" },
                    { label: "DOCTOR NAME", key: "doctorName", w: "100px" },
                    { label: "HOSPITAL NAME", key: "hospitalName", w: "110px" },
                    { label: "PHONE", key: "phone", w: "95px" },
                    { label: "GENDER", key: "gender", w: "55px" },
                    { label: "BATTERY", key: "battery", w: "70px" },
                    { label: "REC. STATUS", key: "recordingStatus", w: "100px" },
                    { label: "UPLOADED TIME", key: "uploadedTime", w: "90px" },
                    { label: "ECG FILES", key: "ecgDatasetCount", w: "80px" },
                    { label: "REPORT STATUS", key: "reportStatus", w: "120px" },
                    { label: "DEVICE NO", key: "devicenumber", w: "90px" },
                    { label: "REMARKS", key: "remarks", w: "110px" },
                    { label: "SALES PARTNER", key: "salesPartner", w: "110px" },
                    { label: "EDIT", key: null, w: "45px" },
                    { label: "SHARE", key: null, w: "110px" },
                    { label: "VIEW", key: null, w: "70px" },
                    { label: "TRIGGER", key: null, w: "90px" },
                    { label: "RAW DATA", key: null, w: "80px" },
                    { label: "CONFIRM", key: null, w: "140px" },
                    { label: "REQUEST FD", key: null, w: "150px" },
                  ].map(({ label, key, w }) => (
                    <th
                      key={label}
                      onClick={key ? () => this.handleSort(key) : undefined}
                      style={{
                        padding: "8px 6px",
                        color: "#0a8aa0",
                        fontWeight: 700,
                        fontSize: "10px",
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #dde3e8",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        width: w,
                        cursor: key ? "pointer" : "default",
                      }}
                    >
                      {label}
                      {key && sortColumn === key && (sortDirection === "asc" ? " ▲" : " ▼")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((patient, index) => {
                  const globalIndex = (currentPage - 1) * (this.state.itemsPerPage || 50) + (index + 1);
                  const hasUploaded = !!patient.updatedDate;

                  const recStatusColor =
                    patient.recordingStatus === "In Recording" ? "#2ecc71"
                    : patient.recordingStatus === "Data Upload" ? "#5ac8fa"
                    : "#ff453a";
                  const recStatusBg =
                    patient.recordingStatus === "In Recording" ? "rgba(46,204,113,0.12)"
                    : patient.recordingStatus === "Data Upload" ? "rgba(90,200,250,0.12)"
                    : "rgba(255,69,58,0.12)";

                  const batteryNum = parseInt(patient.battery) || 0;
                  const batteryColor = batteryNum > 50 ? "#2ecc71" : batteryNum > 20 ? "#f39c12" : "#ff453a";

                  const canShare = patient.ReportPublished !== "NA" &&
                    (patient.whatsappsenttime || (patient.mailsentime && patient.QC === true)) &&
                    (patient.BlockReport === "Yes" || !patient.BlockReport);
                  const canView = patient.ReportPublished !== "NA" &&
                    (patient.whatsappsenttime || (patient.mailsentime && patient.QC === true)) &&
                    (patient.BlockReport === "No" || !patient.BlockReport);

                  const deliveredTime = patient.whatsappsenttime || patient.mailsentime || null;

                  // Once the report is generated, the confirmation window is closed —
                  // partners can no longer confirm (server enforces this too).
                  const reportGenerated = isReportGenerated(patient);

                  return (
                    <React.Fragment key={patient.slno}>
                      <tr style={{ background: index % 2 === 0 ? "#f4f7f9" : "#ffffff", borderBottom: "1px solid #e9eef2" }}>

                        {/* SL NO */}
                        <td style={{ padding: "7px 6px", color: "#5b6770", textAlign: "center", verticalAlign: "middle" }}>{globalIndex}</td>

                        {/* Patient ID / Name — click the id to open the
                            device control popup (live status + commands) */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle" }}>
                          <div
                            onClick={() => this.openDevicePopup(patient)}
                            title="Open device status & controls"
                            style={{ color: "#0a8aa0", fontWeight: 600, fontSize: "15px", cursor: "pointer", textDecoration: "underline", textDecorationColor: "rgba(10,138,160,0.4)" }}
                          >
                            {patient.patientId}
                          </div>
                          <div style={{ color: "#1f2933", fontSize: "12px", marginTop: 3 }}>{patient.name}</div>
                          {patient.ipop && patient.ipop !== "N/A" && (
                            <div style={{ color: "#5b6770", fontSize: "11px", marginTop: 2 }}>
                              IP/OP: <span style={{ color: "#1f2933", fontWeight: 600 }}>{patient.ipop}</span>
                            </div>
                          )}
                        </td>

                        {/* Created Date / Duration */}
                        {(() => {
                          const match = (patient.duration || "").match(/^(\d+)\s*\((.+)\)$/);
                          const durationDays = match ? match[1] : patient.duration;
                          // Show the patient's real registration date
                          // (created_at). The duration string's parenthesised
                          // value is the SUBSCRIBE-log time, which falls back to
                          // "today" when no subscribe log exists (writer down
                          // since July 21) — that was the wrong "created date".
                          const createdDateTime =
                            patient.createdDate && patient.createdDate !== "N/A"
                              ? patient.createdDate
                              : "—";
                          return (
                            <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                              <div style={{ color: "#1f2933", fontSize: "12px", fontWeight: 600 }}>{createdDateTime}</div>
                              {patient.createdTime && (
                                <div style={{ color: "#5b6770", fontSize: "11px", marginTop: 1, fontVariantNumeric: "tabular-nums" }}>{patient.createdTime}</div>
                              )}
                              <div style={{ color: "#0a8aa0", fontSize: "14px", fontWeight: 700, marginTop: 4 }}>{durationDays} {durationDays === "1" ? "Day" : "Days"}</div>
                            </td>
                          );
                        })()}

                        {/* Doctor Name */}
                        <td style={{ padding: "7px 6px", color: "#1f2933", verticalAlign: "middle", textAlign: "center" }}>{patient.doctorName}</td>

                        {/* Hospital Name */}
                        <td style={{ padding: "7px 6px", color: "#1f2933", verticalAlign: "middle", textAlign: "center" }}>{patient.hospitalName}</td>

                        {/* Phone */}
                        <td style={{ padding: "7px 6px", color: "#1f2933", verticalAlign: "middle", textAlign: "center" }}>{patient.phone}</td>

                        {/* Gender */}
                        <td style={{ padding: "7px 6px", color: "#1f2933", verticalAlign: "middle", textAlign: "center" }}>{patient.gender}</td>

                        {/* Battery */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                            <svg width="16" height="10" viewBox="0 0 20 12" fill="none">
                              <rect x="0.5" y="0.5" width="17" height="11" rx="2" stroke={batteryColor} strokeWidth="1.2"/>
                              <rect x="17.5" y="3.5" width="2" height="5" rx="1" fill={batteryColor}/>
                              <rect x="2" y="2" width={Math.round(13 * batteryNum / 100)} height="8" rx="1" fill={batteryColor}/>
                            </svg>
                            <span style={{ color: batteryColor, fontWeight: 600, fontSize: "11px" }}>{patient.battery}</span>
                          </div>
                        </td>

                        {/* Recording Status */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          <span style={{ padding: "3px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: 600, color: recStatusColor, background: recStatusBg, whiteSpace: "nowrap" }}>
                            {patient.recordingStatus}
                          </span>
                        </td>

                        {/* Uploaded Time — date + time on two lines so the
                            column can be narrower. */}
                        {(() => {
                          const raw = patient.uploadedTime && patient.uploadedTime !== "_"
                            ? String(patient.uploadedTime) : "";
                          const parts = raw ? raw.replace("T", " ").split(" ") : [];
                          const dOnly = parts[0] || "";
                          const tOnly = parts[1] ? parts[1].slice(0, 5) : "";
                          const col = hasUploaded ? "#2ecc71" : "#5b6770";
                          return (
                            <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center", fontSize: "11px" }}>
                              {dOnly ? (
                                <>
                                  <div style={{ color: col, fontWeight: 600 }}>{dOnly}</div>
                                  {tOnly && <div style={{ color: "#8095a3", fontVariantNumeric: "tabular-nums" }}>{tOnly}</div>}
                                </>
                              ) : (
                                <span style={{ color: "#5b6770" }}>—</span>
                              )}
                            </td>
                          );
                        })()}

                        {/* ECG files — number of uploaded ECG datasets */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          <span style={{ fontWeight: 700, fontSize: "13px", color: patient.ecgDatasetCount > 0 ? "#0a8aa0" : "#adb8bf" }}>
                            {patient.ecgDatasetCount != null ? patient.ecgDatasetCount : 0}
                          </span>
                        </td>

                        {/* Report Status — partner-facing, simple:
                            Report Ready or Processing. No internal
                            analysis stages or progress shown. */}
                        {(() => {
                          const stage = reportStageOf(patient);
                          return (
                            <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                              <span style={{ display: "inline-block", padding: "3px 10px", borderRadius: "10px", fontSize: "11px", fontWeight: 700, color: stage.color, background: stage.bg, whiteSpace: "nowrap" }}>
                                {stage.label}
                              </span>
                            </td>
                          );
                        })()}

                        {/* Device No — click to see this device's history
                            (same subscribe log the support page shows) */}
                        <td style={{ padding: "7px 6px", color: "#1f2933", verticalAlign: "middle", textAlign: "center" }}>
                          {patient.macId ? (
                            <button
                              type="button"
                              title="View device history"
                              onClick={() => this.openDeviceHistory(patient)}
                              style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                color: "#0a8aa0",
                                fontWeight: 600,
                                textDecoration: "underline",
                                cursor: "pointer",
                                font: "inherit",
                              }}
                            >
                              {patient.devicenumber}
                            </button>
                          ) : (
                            patient.devicenumber
                          )}
                        </td>

                        {/* Remarks — shows the saved remark (hover for full
                            text); click opens the existing #remarkmodal
                            preloaded for this patient */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          <div
                            data-toggle="modal"
                            data-target="#remarkmodal"
                            onClick={() =>
                              this.setState({
                                user_id: patient.userid,
                                remarks: patient.remarks || "",
                              })
                            }
                            title={patient.remarks ? patient.remarks : "Add remarks"}
                            style={{
                              cursor: "pointer",
                              margin: "0 auto",
                              maxWidth: "110px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              fontSize: "11px",
                              color: patient.remarks ? "#1f2933" : "#0a8aa0",
                              textDecoration: patient.remarks ? "none" : "underline",
                            }}
                          >
                            {patient.remarks ? patient.remarks : "+ Add"}
                          </div>
                        </td>

                        {/* Sales partner — the distributor assigns each
                            patient to one of their sales partners; click
                            opens #salespartnermodal preloaded */}
                        {(() => {
                          const sp1 = String(patient.salesPartner || "").trim();
                          const sp2 = String(patient.salesPartner2 || "").trim();
                          const both = [sp1, sp2].filter(Boolean);
                          return (
                            <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                              <div
                                data-toggle="modal"
                                data-target="#salespartnermodal"
                                onClick={() =>
                                  this.setState({
                                    user_id: patient.userid,
                                    salesPartnerSelect: sp1,
                                    salesPartnerInput: "",
                                    salesPartnerSelect2: sp2,
                                    salesPartnerInput2: "",
                                  })
                                }
                                title={both.length ? both.join(" + ") : "Assign sales partner(s)"}
                                style={{
                                  cursor: "pointer",
                                  margin: "0 auto",
                                  maxWidth: "110px",
                                  fontSize: "11px",
                                  color: both.length ? "#1f2933" : "#0a8aa0",
                                  textDecoration: both.length ? "none" : "underline",
                                }}
                              >
                                {both.length ? (
                                  both.map((n, i) => (
                                    <div key={i} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{n}</div>
                                  ))
                                ) : "+ Assign"}
                              </div>
                            </td>
                          );
                        })()}

                        {/* Edit icon */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          <button
                            id={patient.userid}
                            data-toggle="modal"
                            data-target="#editInfoModal"
                            onClick={this.getInfo}
                            title="Edit"
                            style={{ background: "#cdd7df", border: "1px solid #0a8aa0", borderRadius: "7px", width: "32px", height: "32px", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", padding: 0 }}
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0a8aa0" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                            </svg>
                          </button>
                        </td>

                        {/* Share Report */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          {canShare ? (
                            <div>
                              <button
                                className="Report-btn"
                                id={patient.userid}
                                data-toggle="modal"
                                data-target="#mailinfomodal"
                                onClick={() => this.getReport(patient.userid)}
                                style={{ padding: "4px 14px", fontSize: "11px", background: "#cdd7df", border: "1px solid #0a8aa0", borderRadius: "6px", color: "#1f2933", cursor: "pointer", fontWeight: 600 }}
                              >
                                Share
                              </button>
                              {deliveredTime && (
                                <div style={{ fontSize: "10px", color: "#5b6770", marginTop: 3 }}>{deliveredTime}</div>
                              )}
                            </div>
                          ) : (
                            <span style={{ padding: "3px 10px", borderRadius: "10px", fontSize: "11px", color: "#ff453a", background: "rgba(255,69,58,0.12)", fontWeight: 600 }}>Not Ready</span>
                          )}
                        </td>

                        {/* View Report */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          {canView ? (
                            <button
                              onClick={() => {
                                const cleanName = patient.name.replace(/[\s_]+/g, "_");
                                const pdfUrl = `${apiUrl3}assets/dist/user_records/${patient.patientId}/Biocalculus_${cleanName}_${patient.patientId}.pdf`;
                                window.open(pdfUrl, "_blank", "noopener,noreferrer");
                              }}
                              style={{ padding: "4px 12px", fontSize: "11px", background: "#cdd7df", border: "1px solid #5ac8fa", borderRadius: "6px", color: "#5ac8fa", cursor: "pointer", fontWeight: 600 }}
                            >
                              View
                            </button>
                          ) : (
                            <span style={{ padding: "3px 10px", borderRadius: "10px", fontSize: "11px", color: "#5b6770", background: "rgba(137,168,192,0.1)" }}>N/A</span>
                          )}
                        </td>

                        {/* Trigger — ask the device to upload its recorded data now.
                            Pointless once the report exists, so closed then. */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          {reportGenerated ? (
                            <span style={{ padding: "3px 10px", borderRadius: "10px", fontSize: "11px", color: "#5b6770", background: "rgba(137,168,192,0.1)" }}>—</span>
                          ) : (
                            <button
                              onClick={() => this.triggerUpload(patient)}
                              disabled={!!this.state.triggering[patient.userid]}
                              title="Trigger data upload from the device"
                              style={{
                                padding: "4px 12px", fontSize: "11px",
                                background: this.state.triggered[patient.userid] ? "#eef2f5" : "#fff4e5",
                                border: "1px solid #f0a52e", borderRadius: "6px",
                                color: "#a86a00", fontWeight: 600,
                                cursor: this.state.triggering[patient.userid] ? "wait" : "pointer",
                                opacity: this.state.triggering[patient.userid] ? 0.6 : 1,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {this.state.triggering[patient.userid]
                                ? "…"
                                : this.state.triggered[patient.userid]
                                ? "↻ Again"
                                : "⚡ Trigger"}
                            </button>
                          )}
                        </td>

                        {/* Raw data — always the unanalysed view (partners never see the
                            analysed chart), available whether or not analysis has run,
                            until the report is generated. */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          {!patient.lastDatasetId || patient.backupStatus === 1 ? (
                            <span style={{ padding: "3px 10px", borderRadius: "10px", fontSize: "11px", color: "#5b6770", background: "rgba(137,168,192,0.1)" }}>No data</span>
                          ) : reportGenerated ? (
                            <span
                              title="Report generated — raw data view is closed; use View for the report"
                              style={{ padding: "3px 10px", borderRadius: "10px", fontSize: "11px", color: "#5b6770", background: "rgba(137,168,192,0.1)" }}
                            >
                              —
                            </span>
                          ) : (
                            <button
                              onClick={() => this.openRawData(patient)}
                              title="Open raw uploaded data in a new tab"
                              style={{ padding: "4px 12px", fontSize: "11px", background: "#e8f0f6", border: "1px solid #7aa7c7", borderRadius: "6px", color: "#2f6690", cursor: "pointer", fontWeight: 600 }}
                            >
                              Raw ↗
                            </button>
                          )}
                        </td>

                        {/* Confirm uploaded data — records who + when */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          {patient.ConfirmupdatedDate ? (
                            <div
                              title={`Confirmed by ${patient.ConfirmedBy || "—"} on ${String(patient.ConfirmupdatedDate).replace("T", " ").slice(0, 19)}`}
                              style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: "2px", fontSize: "10px", color: "#1f7a3a", background: "rgba(48,209,88,0.12)", padding: "3px 8px", borderRadius: "10px", fontWeight: 600 }}
                            >
                              <span>✅ Confirmed{patient.expDays !== "" && patient.expDays != null ? ` · ${patient.expDays}d` : ""}</span>
                              <span style={{ fontWeight: 500, color: "#3d5a48" }}>
                                {patient.ConfirmedBy || "—"} · {String(patient.ConfirmupdatedDate).replace("T", " ").slice(0, 16)}
                              </span>
                            </div>
                          ) : reportGenerated ? (
                            <span
                              title="Report already generated — confirmation is closed"
                              style={{ padding: "3px 10px", borderRadius: "10px", fontSize: "11px", color: "#5b6770", background: "rgba(137,168,192,0.1)" }}
                            >
                              Closed
                            </span>
                          ) : (
                            <button
                              onClick={() => this.confirmPatient(patient)}
                              title="Confirm this patient's uploaded data"
                              style={{ padding: "4px 12px", fontSize: "11px", background: "#e9f7ee", border: "1px solid #30d158", borderRadius: "6px", color: "#1f7a3a", cursor: "pointer", fontWeight: 600 }}
                            >
                              Confirm
                            </button>
                          )}
                        </td>

                        {/* Request FD — Full Disclosure report, e-mailed to the address the partner gives */}
                        <td style={{ padding: "7px 6px", verticalAlign: "middle", textAlign: "center" }}>
                          {(() => {
                            const fd = (this.state.fdRequests || {})[patient.userid];
                            if (patient.backupStatus === 1) {
                              return (
                                <span
                                  title="Data is not available. Please contact customer support."
                                  style={{ padding: "3px 10px", borderRadius: "10px", fontSize: "11px", color: "#a61b1b", background: "#fdecec", cursor: "help" }}
                                >
                                  Data is not available. Please contact customer support.
                                </span>
                              );
                            }
                            if (!(patient.ecgDatasetCount > 0)) {
                              return (
                                <span
                                  title="No ECG files uploaded yet — nothing to disclose"
                                  style={{ padding: "3px 10px", borderRadius: "10px", fontSize: "11px", color: "#5b6770", background: "rgba(137,168,192,0.1)" }}
                                >
                                  —
                                </span>
                              );
                            }
                            if (!fd) {
                              return (
                                <button
                                  onClick={() => this.openFdDialog(patient)}
                                  title="Ask for the Full Disclosure report to be e-mailed"
                                  style={{ padding: "4px 12px", fontSize: "11px", background: "#e6f6f9", border: "1px solid #0a8aa0", borderRadius: "6px", color: "#075e6d", cursor: "pointer", fontWeight: 600 }}
                                >
                                  Request FD
                                </button>
                              );
                            }
                            const look = {
                              sent:       { text: "FD sent",       fg: "#1f7a3a", bg: "#e9f7ee", bd: "#30d158" },
                              processing: { text: "FD processing", fg: "#8a5a00", bg: "#fff6e0", bd: "#f0b429" },
                              requested:  { text: "FD requested",  fg: "#075e6d", bg: "#e6f6f9", bd: "#0a8aa0" },
                              failed:     { text: "FD failed",     fg: "#a61b1b", bg: "#fdecec", bd: "#e57373" },
                            }[fd.status] || { text: "FD " + fd.status, fg: "#3e4c59", bg: "#eef2f5", bd: "#c9d3dc" };
                            return (
                              <div
                                title={`${look.text} · requested ${new Date(fd.requestedAt).toLocaleString()}${fd.requestedBy ? " by " + fd.requestedBy : ""} → ${(fd.emails || []).join(", ")}${fd.count > 1 ? ` · ${fd.count} requests in total` : ""}`}
                                style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: "3px" }}
                              >
                                <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "10px", fontWeight: 700, color: look.fg, background: look.bg, border: `1px solid ${look.bd}` }}>
                                  {look.text}
                                </span>
                                {fd.status === "failed" && (
                                  <span style={{ fontSize: "10px", color: "#a61b1b", maxWidth: "140px", lineHeight: 1.3 }}>
                                    Data is not available. Please contact customer support.
                                  </span>
                                )}
                                <span style={{ fontSize: "10px", color: "#5b6770" }}>
                                  {new Date(fd.requestedAt).toLocaleDateString([], { day: "2-digit", month: "short" })}{" "}
                                  {new Date(fd.requestedAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                                </span>
                                <button
                                  onClick={() => this.openFdDialog(patient)}
                                  title="Send a new FD request (for example to another address)"
                                  style={{ padding: "1px 8px", fontSize: "10px", background: "none", border: "1px solid #c9d3dc", borderRadius: "5px", color: "#3e4c59", cursor: "pointer" }}
                                >
                                  Request again
                                </button>
                              </div>
                            );
                          })()}
                        </td>
                      </tr>

                      {/* Progress bar row */}
                      {patient.recordingStatus !== "Data Upload" && (
                        <tr style={{ background: "transparent" }}>
                          <td colSpan="22" style={{ padding: "0 12px 6px" }}>
                            <div style={{ width: "100%", height: "3px", background: "#e9eef2", borderRadius: "10px", overflow: "hidden" }}>
                              <div style={{ width: `${patient.percentage}%`, height: "100%", background: "#0a8aa0", borderRadius: "5px" }} />
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", padding: "16px" }}>
          <button onClick={this.handlePrevPage} disabled={currentPage === 1}
            style={{ padding: "5px 16px", fontSize: "12px", borderRadius: "6px", border: "1px solid #0a8aa0", background: currentPage === 1 ? "#eef2f5" : "#cdd7df", color: currentPage === 1 ? "#a7b4be" : "#1f2933", cursor: currentPage === 1 ? "not-allowed" : "pointer" }}>
            ‹ Prev
          </button>
          {visiblePageButtons.map((pageNumber) => (
            <button key={pageNumber} onClick={() => this.handlePageChange(pageNumber)}
              style={{ padding: "5px 10px", fontSize: "12px", borderRadius: "6px", border: "1px solid #0a8aa0", background: pageNumber === currentPage ? "#0a8aa0" : "#eef2f5", color: pageNumber === currentPage ? "#f4f7f9" : "#5b6770", fontWeight: pageNumber === currentPage ? 700 : 400, cursor: "pointer" }}>
              {pageNumber}
            </button>
          ))}
          <button onClick={this.handleNextPage} disabled={currentPage === totalPages}
            style={{ padding: "5px 16px", fontSize: "12px", borderRadius: "6px", border: "1px solid #0a8aa0", background: currentPage === totalPages ? "#eef2f5" : "#cdd7df", color: currentPage === totalPages ? "#a7b4be" : "#1f2933", cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}>
            Next ›
          </button>
        </div>
        </div>{/* end page-wrapper */}
      </div>
    );
  }
}

// kept for any remaining references
const headerStyle = { padding: "7px 6px", color: "#0a8aa0", fontWeight: 700, fontSize: "10px", textAlign: "center", background: "#eef2f5", borderBottom: "1px solid #dde3e8" };
const cellStyle = { padding: "7px 6px", color: "#1f2933", textAlign: "center", verticalAlign: "middle" };
const rowStyle = { borderBottom: "1px solid #e9eef2" };
const searchStyle = {};
const paginationStyle = {};
const pageButtonStyle = {};
const tableWrapperStyle = { overflowX: "auto" };

export default Distributor;
